const SIZE = 40;
// eslint-disable-next-line import/prefer-default-export
export const PianoIcon = () => {
  return (
    <svg
      width={SIZE}
      height={SIZE}
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z"
        fill="#64ABC9"
      />
      <path
        d="M125.318 82.3918L67.5857 24.6598L18.8337 101.018L41.8962 124.08C48.7855 126.616 56.231 128 64 128C92.9532 128 117.416 108.774 125.318 82.3918Z"
        fill="#2D697B"
      />
      <path
        d="M66.8287 43.6297C66.8287 43.6297 68.3692 23.803 62.1935 18.9032C57.6307 15.2832 51.8587 13.1212 45.582 13.1212C30.8095 13.1212 18.8337 25.0967 18.8337 39.8695V101.018H28.0987L64.5 93.627L99.2375 101.018H110.166C110.166 101.018 91.521 67.4865 80.6112 65.6977C80.6112 65.6975 66.8287 50.9595 66.8287 43.6297Z"
        fill="#4C4C4C"
      />
      <path
        d="M110.165 77.9534V101.018H100.901L64.5004 93.6259L62.1929 94.1159V18.9034C68.3704 23.8034 72.3304 31.3734 72.3304 39.8684C72.3304 47.1984 77.6404 53.4509 84.8729 54.6359L91.2479 55.6809C102.158 57.4709 110.165 66.8984 110.165 77.9534Z"
        fill="#2B2B2B"
      />
      <path d="M28.0986 78.6337H100.901V101.018H28.0986V78.6337Z" fill="white" />
      <path d="M62.1929 78.6335H100.901V101.018H62.1929V78.6335Z" fill="#DBDBDB" />
      <path d="M36.301 71.433H44.2385V91.0037H36.301V71.433Z" fill="#4C4C4C" />
      <path d="M52.4512 71.433H60.3887V91.0037H52.4512V71.433Z" fill="#4C4C4C" />
      <path d="M68.6018 71.433H76.5393V91.0037H68.6018V71.433Z" fill="#2B2B2B" />
      <path d="M84.752 71.433H92.6895V91.0037H84.752V71.433Z" fill="#2B2B2B" />
    </svg>
  );
};

export const OrganIcon = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 128 129"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64 128.688C99.3462 128.688 128 100.034 128 64.6875C128 29.3413 99.3462 0.6875 64 0.6875C28.6538 0.6875 0 29.3413 0 64.6875C0 100.034 28.6538 128.688 64 128.688Z"
      fill="#E3B967"
    />
    <path
      d="M27.4805 117.252C26.5141 113.237 26 109.027 26 104.688C26 77.0732 48.3188 47.6875 74 47.6875C97.6029 47.6875 115.599 73.5966 118.599 98.0951C124.562 88.3706 128 76.9305 128 64.6875C128 29.3413 99.3462 0.6875 64 0.6875C28.6538 0.6875 0 29.3413 0 64.6875C0 86.4587 10.8708 105.691 27.4805 117.252Z"
      fill="#E5C587"
    />
    <path
      d="M102.558 71.9923H26.1531V60.4906C26.1531 59.1044 27.2769 57.9807 28.6631 57.9807H100.048C101.434 57.9807 102.558 59.1044 102.558 60.4906V71.9923H102.558Z"
      fill="#9A6A53"
    />
    <path
      d="M100.048 57.9807H95.436C96.8222 57.9807 97.946 59.1044 97.946 60.4906V71.9923H102.558V60.4906C102.558 59.1044 101.434 57.9807 100.048 57.9807Z"
      fill="#855B47"
    />
    <path d="M32.9048 30.3265H38.1466V57.9806H32.9048V30.3265Z" fill="#EDC472" />
    <path d="M38.1465 32.6387H43.3883V57.9807H38.1465V32.6387Z" fill="#BC9B5B" />
    <path d="M43.3884 27.8405H48.6302V57.9808H43.3884V27.8405Z" fill="#EDC472" />
    <path d="M48.6301 32.6387H53.8719V57.9807H48.6301V32.6387Z" fill="#BC9B5B" />
    <path d="M53.8718 30.3265H59.1136V57.9806H53.8718V30.3265Z" fill="#EDC472" />
    <path d="M59.1138 27.8405H64.3556V57.9808H59.1138V27.8405Z" fill="#BC9B5B" />
    <path d="M64.3555 30.3265H69.5973V57.9806H64.3555V30.3265Z" fill="#EDC472" />
    <path d="M69.5972 32.6387H74.839V57.9807H69.5972V32.6387Z" fill="#BC9B5B" />
    <path d="M74.8391 28.6055H80.0809V57.9808H74.8391V28.6055Z" fill="#EDC472" />
    <path d="M80.0808 35.4153H85.3226V57.9806H80.0808V35.4153Z" fill="#BC9B5B" />
    <path d="M85.3225 32.6387H90.5643V57.9807H85.3225V32.6387Z" fill="#EDC472" />
    <path d="M90.5645 30.3265H95.8063V57.9806H90.5645V30.3265Z" fill="#BC9B5B" />
    <path
      d="M100.499 100.909H28.2123C27.075 100.909 26.1531 99.9875 26.1531 98.8502V72.1661H102.558V98.8501C102.558 99.9875 101.636 100.909 100.499 100.909Z"
      fill="#B78C7A"
    />
    <path d="M35.3892 66.7454H93.3215V71.9922H35.3892V66.7454Z" fill="#F7F7F7" />
    <path d="M31.8525 72.1661H96.8584V100.909H31.8525V72.1661Z" fill="#7A5341" />
    <path
      d="M78.8821 92.1715H46.5637V90.0206C46.5637 87.8491 48.3241 86.0887 50.4956 86.0887H74.9504C77.1219 86.0887 78.8823 87.8491 78.8823 90.0206L78.8821 92.1715Z"
      fill="#CF9875"
    />
    <path d="M48.0078 92.1715H77.4382V100.91H48.0078V92.1715Z" fill="#9A6A53" />
    <path d="M57.3826 49.2179H71.3282V66.728H57.3826V49.2179Z" fill="#F4E2C1" />
    <path
      d="M103.711 60.4906C103.711 58.4709 102.068 56.8277 100.048 56.8277H96.9592V30.3265C96.9592 29.6897 96.4431 29.1735 95.8062 29.1735H90.5644C89.9275 29.1735 89.4114 29.6897 89.4114 30.3265V31.4856H85.3226C84.6857 31.4856 84.1696 32.0019 84.1696 32.6386V34.2624H81.2338V28.6053C81.2338 27.9686 80.7177 27.4523 80.0808 27.4523H74.839C74.202 27.4523 73.686 27.9686 73.686 28.6053V31.4856H70.7501V30.3265C70.7501 29.6897 70.2341 29.1735 69.5971 29.1735H65.5085V27.8405C65.5085 27.2037 64.9924 26.6875 64.3555 26.6875H59.1137C58.4768 26.6875 57.9607 27.2037 57.9607 27.8405V29.1735H53.8719C53.2349 29.1735 52.7189 29.6897 52.7189 30.3265V31.4856H49.7832V27.8405C49.7832 27.2037 49.267 26.6875 48.6302 26.6875H43.3882C42.7513 26.6875 42.2352 27.2037 42.2352 27.8405V31.4856H39.2996V30.3265C39.2996 29.6897 38.7835 29.1735 38.1466 29.1735H32.9048C32.2679 29.1735 31.7518 29.6897 31.7518 30.3265V39.7752C31.7518 40.412 32.2679 40.9282 32.9048 40.9282C33.5417 40.9282 34.0578 40.412 34.0578 39.7752V31.4795H36.9936V32.6386V56.8277H34.0578V44.3872C34.0578 43.7504 33.5417 43.2342 32.9048 43.2342C32.2679 43.2342 31.7518 43.7504 31.7518 44.3872V56.8277H28.663C26.6432 56.8277 25 58.4709 25 60.4906V98.8501C25 100.621 26.4411 102.062 28.2124 102.062H100.499C102.27 102.062 103.711 100.621 103.711 98.8501L103.711 60.4906ZM70.1753 50.3709V65.575H58.5355V50.3709H70.1753ZM92.1688 70.8394H88.9128V67.8985H92.1688V70.8394ZM69.2786 67.8984V70.8393H65.8084V67.8984H69.2786ZM63.5024 67.8984V70.8393H60.0324V67.8984H63.5024ZM86.6069 70.8394H83.1368V67.8985H86.6069V70.8394ZM80.8308 70.8394H77.3608V67.8985H80.8308V70.8394ZM75.0548 70.8394H71.5848V67.8985H75.0548V70.8394ZM57.7264 67.8984V70.8393H54.2563V67.8984H57.7264ZM51.9504 70.8394H48.4803V67.8985H51.9504V70.8394ZM46.1742 70.8394H42.704V67.8985H46.1742V70.8394ZM40.398 70.8394H36.5422V67.8985H40.398V70.8394ZM101.405 60.4906V70.8393H94.4747V66.7454C94.4747 66.1086 93.9587 65.5924 93.3217 65.5924H72.4813V59.1336H100.048C100.796 59.1336 101.405 59.7424 101.405 60.4906ZM91.7174 31.4795H94.6532V56.8277H91.7174V32.6386V31.4795ZM86.4757 33.7916H89.4116V56.8277H86.4757V35.4153V33.7916ZM84.1697 36.5683V56.8277H81.2338V36.5683H84.1697ZM75.992 29.7583H78.9278V35.4153V56.8277H75.992V32.6386V29.7583ZM73.686 33.7916V56.8277H72.4813V49.2179C72.4813 48.5811 71.9652 48.0649 71.3283 48.0649H70.7501V33.7916H73.686ZM68.4443 31.4795V48.0649H65.5085V31.4795H68.4443ZM60.2667 28.9935H63.2025V48.0651H60.2667V30.3265V28.9935ZM55.025 31.4795H57.9608V48.0649H57.3826C56.7457 48.0649 56.2297 48.5811 56.2297 49.2179V56.8277H55.025V32.6386V31.4795ZM52.719 33.7916V56.8277H49.7832V33.7916H52.719ZM44.5412 28.9935H47.4772V32.6386V56.8277H44.5412V32.6386V28.9935ZM39.2996 33.7916H42.2354V56.8277H39.2996V33.7916ZM27.306 60.4906C27.306 59.7424 27.9148 59.1336 28.663 59.1336H56.2295V65.5924H35.3892C34.7523 65.5924 34.2362 66.1086 34.2362 66.7454V70.8393H27.306V60.4906ZM27.306 98.8502V73.3191H30.6995V99.7565H28.2124C27.7126 99.7565 27.306 99.35 27.306 98.8502ZM49.1606 99.7565V93.3245H76.2851V99.7565H49.1606ZM78.5911 99.7565V93.3245H78.8821C79.519 93.3245 80.0351 92.8083 80.0351 92.1715V90.0206C80.0351 87.2169 77.754 84.9358 74.9504 84.9358H59.0525C58.4156 84.9358 57.8995 85.452 57.8995 86.0888C57.8995 86.7255 58.4156 87.2418 59.0525 87.2418H74.9503C76.4825 87.2418 77.729 88.4884 77.729 90.0206V91.0185H77.4381H48.0076H47.7166V90.0206C47.7166 88.4884 48.963 87.2418 50.4953 87.2418H54.4404C55.0773 87.2418 55.5934 86.7255 55.5934 86.0888C55.5934 85.452 55.0773 84.9358 54.4404 84.9358H50.4953C47.6917 84.9358 45.4106 87.2169 45.4106 90.0206V92.1715C45.4106 92.8083 45.9267 93.3245 46.5636 93.3245H46.8546V99.7565H33.0055V73.3191H95.7055V99.7565H78.5911ZM101.405 98.8502C101.405 99.35 100.998 99.7567 100.499 99.7567H98.0113V73.3191H101.405V98.8502Z"
      fill="black"
    />
  </svg>
);

export const ElectricGuitarIcon = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M112.106 29.8134C112.106 46.9865 88.4601 64.2091 67.5327 67.7695C66.9726 67.8637 66.4148 67.9508 65.8593 68.0238C65.2991 68.1015 64.7413 68.1674 64.1882 68.2216C63.6257 68.2781 63.0679 68.3228 62.5124 68.3582C62.2734 68.3723 62.0343 68.3841 61.7976 68.3958C61.4765 68.41 61.1577 68.4217 60.839 68.4288C60.5601 68.4359 60.2835 68.4382 60.007 68.4382H59.9999C59.7234 68.4382 59.4445 68.4359 59.1656 68.4288C58.6124 68.417 58.0546 68.3911 57.4945 68.3535C56.939 68.3181 56.3812 68.271 55.821 68.2098C55.2655 68.1533 54.7077 68.0827 54.1476 68.0002C53.5921 67.9225 53.0343 67.833 52.4765 67.7318C31.5445 63.9736 7.89368 45.8869 7.89368 29.8134C16.9452 13.9283 32.9812 2.57844 51.7991 0H59.1656H68.2007C87.0163 2.5808 103.057 13.9307 112.106 29.8134Z"
      fill="#F9DC78"
    />
    <path
      d="M120 59.7187C120 93.01 93.1359 120 60 120C26.8641 120 0 93.01 0 59.7187C0 48.8351 2.87109 38.6273 7.89375 29.8135C18.2344 47.9615 37.6969 60.1896 60 60.1896C82.3031 60.1896 101.768 47.9615 112.106 29.8135C117.129 38.6273 120 48.8351 120 59.7187Z"
      fill="#FFCA0F"
    />
    <path
      d="M23.361 82.7505C24.5539 83.3894 26.039 82.9364 26.6733 81.7259L26.8994 81.2942L30.35 83.1414L32.6393 78.7716L29.1888 76.9246L29.4149 76.4931C30.0472 75.2865 29.5892 73.7887 28.3922 73.1481C27.1951 72.5069 25.7122 72.9661 25.0799 74.1726L22.3383 79.4055C21.706 80.612 22.1638 82.1099 23.361 82.7505Z"
      fill="#413B33"
    />
    <path
      d="M29.4076 70.4037C30.6005 71.0426 32.0856 70.5896 32.7199 69.3791L32.946 68.9474L36.3966 70.7946L38.6859 66.4248L35.2354 64.5778L35.4616 64.1463C36.0938 62.9397 35.6358 61.4419 34.4389 60.8013C33.2418 60.1601 31.7588 60.6193 31.1266 61.8258L28.3849 67.0587C27.7526 68.2652 28.2105 69.763 29.4076 70.4037Z"
      fill="#413B33"
    />
    <path
      d="M35.4545 58.057C36.6474 58.6959 38.1325 58.2429 38.7668 57.0324L38.9929 56.6007L42.4435 58.4479L44.7328 54.0782L41.2823 52.2311L41.5084 51.7996C42.1407 50.593 41.6827 49.0952 40.4857 48.4546C39.2886 47.8134 37.8057 48.2726 37.1734 49.4792L34.4318 54.712C33.7995 55.9186 34.2573 57.4164 35.4545 58.057Z"
      fill="#413B33"
    />
    <path
      d="M41.5006 45.7102C42.6935 46.3491 44.1786 45.8961 44.8129 44.6856L45.039 44.2539L48.4897 46.1011L50.7789 41.7314L47.3285 39.8843L47.5546 39.4528C48.1868 38.2462 47.7288 36.7484 46.5319 36.1078C45.3348 35.4666 43.8518 35.9258 43.2196 37.1324L40.4779 42.3652C39.8457 43.5718 40.3035 45.0696 41.5006 45.7102Z"
      fill="#413B33"
    />
    <path
      d="M47.5475 33.3637C48.7404 34.0026 50.2255 33.5495 50.8598 32.3391L51.0859 31.9074L54.5365 33.7546L56.8258 29.3848L53.3753 27.5378L53.6015 27.1062C54.2337 25.8997 53.7757 24.4019 52.5788 23.7612C51.3816 23.1201 49.8987 23.5792 49.2665 24.7858L46.5248 30.0187C45.8925 31.2252 46.3504 32.723 47.5475 33.3637Z"
      fill="#413B33"
    />
    <path
      d="M53.5941 21.017C54.787 21.6559 56.2721 21.2029 56.9064 19.9924L57.1325 19.5607L60.5832 21.4079L62.8725 17.0381L59.422 15.1911L59.6481 14.7595C60.2803 13.553 59.8223 12.0552 58.6254 11.4145C57.4283 10.7734 55.9453 11.2326 55.3131 12.4391L52.5714 17.672C51.9392 18.8785 52.397 20.3763 53.5941 21.017Z"
      fill="#413B33"
    />
    <path
      d="M80.3897 9.61011C76.5808 9.61011 66.6565 11.0768 61.5665 21.2965L29.8796 84.9729C29.418 85.9004 29.4674 87.0018 30.01 87.8839C30.5526 88.7661 31.5111 89.3029 32.5433 89.3029C37.0571 89.3029 40.7294 92.9924 40.7294 97.5274V108.744C40.7294 110.396 42.0628 111.736 43.7074 111.736H66.0359C67.6806 111.736 69.0139 110.396 69.0139 108.744V92.7205C69.0139 89.0689 71.9707 86.0983 75.6052 86.0983C77.2499 86.0983 78.5832 84.7587 78.5832 83.1063V46.2518C78.5832 45.2507 79.3939 44.4365 80.3899 44.4365C89.9467 44.4365 97.7219 36.625 97.7219 27.0232C97.7219 17.4213 89.9467 9.61011 80.3897 9.61011Z"
      fill="#BC0808"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.7896 86.4903C29.7495 87.1024 29.897 87.7222 30.228 88.2603C30.7706 89.1425 31.7291 89.6793 32.7613 89.6793C34.2036 89.6793 35.5601 90.056 36.7382 90.7166C35.3691 88.2523 32.7751 86.5644 29.7896 86.4903ZM40.9474 108.921H63.0773C64.722 108.921 66.0553 107.581 66.0553 105.929V89.9054C66.0553 86.2538 69.0121 83.2832 72.6466 83.2832C74.2913 83.2832 75.6246 81.9436 75.6246 80.2912V43.4367C75.6246 42.4356 76.4352 41.6214 77.4313 41.6214C86.9881 41.6214 94.7633 33.8099 94.7633 24.2081C94.7633 20.219 93.4212 16.5389 91.167 13.5996C95.2832 16.7861 97.9399 21.7869 97.9399 27.3996C97.9399 37.0014 90.1647 44.8128 80.6079 44.8128C79.6119 44.8128 78.8013 45.6271 78.8013 46.6282V83.4827C78.8013 85.1351 77.4679 86.4747 75.8233 86.4747C72.1887 86.4747 69.2319 89.4453 69.2319 93.0969V109.12C69.2319 110.773 67.8986 112.112 66.2539 112.112H43.9254C42.2808 112.112 40.9474 110.773 40.9474 109.12V108.921Z"
      fill="#830808"
    />
  </svg>
);

export const AcousticGuitarIcon = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 126 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M117.089 31.1384C117.089 49.0748 92.3916 67.0628 70.5342 70.7814C69.9491 70.8798 69.3665 70.9708 68.7863 71.0471C68.2013 71.1282 67.6187 71.1971 67.041 71.2536C66.4535 71.3127 65.8709 71.3594 65.2907 71.3963C65.041 71.411 64.7913 71.4233 64.5441 71.4356C64.2087 71.4504 63.8758 71.4627 63.5429 71.4701C63.2516 71.4774 62.9627 71.4799 62.6739 71.4799H62.6665C62.3777 71.4799 62.0864 71.4774 61.7951 71.4701C61.2174 71.4578 60.6348 71.4307 60.0497 71.3914C59.4696 71.3545 58.887 71.3053 58.3019 71.2413C57.7218 71.1823 57.1392 71.1085 56.5541 71.0225C55.9739 70.9413 55.3913 70.8478 54.8087 70.7421C32.9464 66.8169 8.24446 47.9263 8.24446 31.1384C17.6983 14.5473 34.447 2.69304 54.1013 0H61.7951H71.2318C90.8837 2.6955 107.637 14.5498 117.089 31.1384Z"
      fill="#9D9D9D"
    />
    <path
      d="M125.333 62.373C125.333 97.144 97.2753 125.334 62.6666 125.334C28.058 125.334 -4.57764e-05 97.144 -4.57764e-05 62.373C-4.57764e-05 51.0057 2.99865 40.3442 8.24454 31.1387C19.0447 50.0932 39.3722 62.8649 62.6666 62.8649C85.961 62.8649 106.291 50.0932 117.089 31.1387C122.335 40.3442 125.333 51.0057 125.333 62.373Z"
      fill="#6A7C82"
    />
    <path
      d="M94.9067 44.392C95.6421 42.173 95.5969 39.9701 94.7711 37.7831C94.6237 37.393 94.3244 37.0772 93.9463 36.9008C92.1582 36.0659 90.3878 36.1022 88.6354 37.0098C88.2651 37.2016 87.9789 37.5293 87.8475 37.9252C87.1121 40.1442 87.1573 42.3472 87.9832 44.5341C88.1305 44.9242 88.4298 45.24 88.8079 45.4164C90.596 46.2513 92.3664 46.215 94.1189 45.3074C94.4893 45.1156 94.7756 44.788 94.9067 44.392Z"
      fill="#FFF4E5"
    />
    <path
      d="M95.2557 61.3905C95.9911 59.1715 95.9458 56.9685 95.12 54.7816C94.9727 54.3915 94.6734 54.0757 94.2953 53.8993C92.5071 53.0644 90.7367 53.1007 88.9843 54.0083C88.6141 54.2 88.3279 54.5277 88.1965 54.9237C87.4611 57.1427 87.5063 59.3456 88.3321 61.5326C88.4795 61.9227 88.7788 62.2385 89.1568 62.4149C90.945 63.2498 92.7154 63.2135 94.4678 62.3059C94.8381 62.1141 95.1243 61.7864 95.2557 61.3905Z"
      fill="#FFF4E5"
    />
    <path
      d="M95.6044 78.3889C96.3398 76.1699 96.2946 73.9669 95.4687 71.78C95.3214 71.3899 95.0221 71.0741 94.644 70.8977C92.8559 70.0628 91.0855 70.0991 89.333 71.0067C88.9628 71.1985 88.6766 71.5261 88.5452 71.9221C87.8098 74.1411 87.855 76.344 88.6808 78.531C88.8282 78.9211 89.1275 79.2369 89.5056 79.4133C91.2937 80.2482 93.0641 80.2119 94.8165 79.3043C95.187 79.1125 95.4731 78.7847 95.6044 78.3889Z"
      fill="#FFF4E5"
    />
    <path
      d="M30.236 45.7191C29.4102 43.5322 29.365 41.3292 30.1004 39.1102C30.2316 38.7144 30.5177 38.3866 30.8882 38.1948C32.6406 37.2873 34.411 37.2509 36.1992 38.0858C36.577 38.2622 36.8765 38.578 37.0239 38.9681C37.8497 41.1551 37.8949 43.358 37.1595 45.5771C37.0283 45.9728 36.7422 46.3007 36.3717 46.4924C34.6193 47.4 32.8489 47.4363 31.0607 46.6014C30.6827 46.425 30.3832 46.1093 30.236 45.7191Z"
      fill="#FFF4E5"
    />
    <path
      d="M30.5847 62.7176C29.7589 60.5306 29.7137 58.3276 30.4491 56.1086C30.5803 55.7128 30.8664 55.385 31.2369 55.1932C32.9893 54.2857 34.7597 54.2494 36.5479 55.0843C36.9257 55.2607 37.2252 55.5765 37.3726 55.9665C38.1984 58.1535 38.2436 60.3565 37.5082 62.5755C37.377 62.9713 37.0909 63.2991 36.7204 63.4909C34.968 64.3984 33.1976 64.4348 31.4094 63.5999C31.0316 63.4234 30.7322 63.1078 30.5847 62.7176Z"
      fill="#FFEBCE"
    />
    <path
      d="M30.9336 79.7161C30.1078 77.5292 30.0626 75.3262 30.798 73.1072C30.9293 72.7114 31.2154 72.3836 31.5858 72.1918C33.3383 71.2842 35.1087 71.2479 36.8968 72.0828C37.2746 72.2592 37.5741 72.5749 37.7215 72.9651C38.5474 75.1521 38.5926 77.355 37.8572 79.574C37.7259 79.9698 37.4398 80.2976 37.0693 80.4894C35.3169 81.397 33.5465 81.4333 31.7584 80.5984C31.3803 80.422 31.081 80.1062 30.9336 79.7161Z"
      fill="#FFEBCE"
    />
    <path
      d="M82.5584 32.9678L83.26 70.8989C76.439 80.1773 62.7159 81.3863 53.6385 75.9443C48.9112 73.1097 44.5555 65.376 42.6748 59.0964L42.6737 59.0953L42.1057 33.8749C42.0154 29.8689 45.5465 26.7398 49.5134 27.3128L59.0231 28.6866C60.7254 28.9325 62.4566 28.905 64.1501 28.6078L74.953 26.7037C78.8743 26.0134 82.4848 28.9867 82.5584 32.9678Z"
      fill="#CC740D"
    />
    <path
      d="M83.2601 70.8989L83.4475 80.9794C83.4792 82.6945 82.9648 84.3771 81.9793 85.783L75.737 94.6809L64.1291 98.6805L51.4527 95.1792L44.8506 86.5449C43.8083 85.1807 43.2253 83.5205 43.1866 81.8056L42.6736 59.0952C45.0661 63.8733 48.6726 67.939 53.3999 70.7736C62.4773 76.2157 73.6045 75.8739 83.2601 70.8989Z"
      fill="#CC740D"
    />
    <path
      d="M75.8333 40.1122C76.6026 40.8506 76.6277 42.0728 75.8894 42.8421C75.151 43.6114 73.9288 43.6364 73.1595 42.8981C72.3902 42.1597 72.3651 40.9375 73.1035 40.1683C73.8419 39.399 75.064 39.3739 75.8333 40.1122Z"
      fill="#F4C34C"
      stroke="#F4C34C"
    />
    <path
      d="M76.1823 57.1106C76.9516 57.849 76.9767 59.0712 76.2383 59.8405C75.5 60.6098 74.2778 60.6348 73.5085 59.8965C72.7392 59.1581 72.7141 57.936 73.4525 57.1667C74.1908 56.3974 75.413 56.3723 76.1823 57.1106Z"
      fill="#F4C34C"
      stroke="#F4C34C"
    />
    <path
      d="M76.531 74.1091C77.3003 74.8475 77.3254 76.0697 76.587 76.8389C75.8487 77.6082 74.6265 77.6333 73.8572 76.895C73.0879 76.1566 73.0628 74.9344 73.8012 74.1651C74.5395 73.3958 75.7617 73.3708 76.531 74.1091Z"
      fill="#F4C34C"
      stroke="#F4C34C"
    />
    <path
      d="M51.8475 40.6044C52.6168 41.3428 52.6419 42.565 51.9035 43.3342C51.1652 44.1035 49.943 44.1286 49.1737 43.3903C48.4044 42.6519 48.3793 41.4297 49.1177 40.6604C49.856 39.8911 51.0782 39.8661 51.8475 40.6044Z"
      fill="#F4C34C"
      stroke="#F4C34C"
    />
    <path
      d="M52.1962 57.6029C52.9655 58.3412 52.9906 59.5634 52.2522 60.3327C51.5139 61.102 50.2917 61.1271 49.5224 60.3887C48.7531 59.6504 48.728 58.4282 49.4664 57.6589C50.2047 56.8896 51.4269 56.8645 52.1962 57.6029Z"
      fill="#F4C34C"
      stroke="#F4C34C"
    />
    <path
      d="M52.5452 74.6014C53.3145 75.3397 53.3395 76.5619 52.6012 77.3312C51.8628 78.1005 50.6407 78.1256 49.8714 77.3872C49.1021 76.6489 49.077 75.4267 49.8153 74.6574C50.5537 73.8881 51.7759 73.863 52.5452 74.6014Z"
      fill="#F4C34C"
      stroke="#F4C34C"
    />
    <path
      d="M75.9558 105.365L75.8528 100.347L63.2761 97.401L51.5694 100.845L51.6724 105.864C51.7274 108.546 53.9465 110.676 56.6288 110.621L71.199 110.322C73.8812 110.267 76.011 108.047 75.9558 105.365Z"
      fill="#8697A6"
    />
    <path
      d="M51.4522 95.1692L75.732 94.6709L75.8483 100.336L51.5685 100.835L51.4522 95.1692Z"
      fill="#FFEBCE"
    />
  </svg>
);

export const BassIcon = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 22.3858 22.3858 0 50 0C77.6142 0 100 22.3858 100 50Z"
      fill="#0D98A8"
    />
    <path
      d="M93.7122 25.9758C93.7122 40.3624 73.8101 54.7904 56.1962 57.773C55.7248 57.852 55.2553 57.9249 54.7877 57.9861C54.3163 58.0512 53.8468 58.1064 53.3812 58.1518C52.9078 58.1991 52.4383 58.2366 51.9708 58.2662C51.7696 58.278 51.5684 58.2879 51.3691 58.2978C51.0989 58.3096 50.8306 58.3195 50.5623 58.3254C50.3276 58.3313 50.0948 58.3333 49.862 58.3333H49.8561C49.6233 58.3333 49.3886 58.3313 49.1538 58.3254C48.6883 58.3155 48.2188 58.2938 47.7473 58.2623C47.2798 58.2327 46.8103 58.1932 46.3388 58.1419C45.8713 58.0946 45.4018 58.0354 44.9304 57.9664C44.4629 57.9013 43.9934 57.8263 43.5239 57.7415C25.9061 54.5931 6 39.4412 6 25.9758C13.6184 12.6683 27.1153 3.16006 42.9538 1H49.1538H56.7584C72.5949 3.16203 86.0958 12.6702 93.7122 25.9758Z"
      fill="#00B3C7"
    />
    <path
      d="M36.3369 84.2254L33.6512 93.7575C33.3951 94.6664 33.9165 95.6036 34.7877 95.7999L49.8119 99.186C50.6831 99.3824 51.5407 98.7562 51.681 97.821L53.153 88.0137C47.5506 86.7377 41.9506 85.4493 36.3369 84.2254Z"
      fill="#D68A5A"
    />
    <path
      d="M36.339 84.226L34.6599 90.1865L41.1654 91.653C43.9977 92.2915 45.8439 95.1504 45.3877 98.1908L49.8131 99.1874C50.6841 99.3837 51.5415 98.7573 51.6817 97.8223L53.1538 88.0146C47.5516 86.7385 41.9521 85.4501 36.339 84.226Z"
      fill="#C79923"
    />
    <path
      d="M52.947 89.4371L53.8546 83.3895L37.6111 79.7286L35.9547 85.6074L52.947 89.4371Z"
      fill="#123A2B"
    />
    <path
      d="M53.8547 83.3966L52.9464 89.4446L48.4586 88.4331L49.3668 82.3851L53.8547 83.3966Z"
      fill="#111A16"
    />
    <path
      d="M61.5594 33.3477C65.3166 31.736 68.2461 28.1242 68.8929 23.4905C69.7406 17.4168 66.3191 11.7418 60.7758 10.0248C54.5852 8.10738 48.2076 11.8281 46.2105 18.0833L29.6828 68.6775C29.2595 69.9785 29.5831 71.4094 30.513 72.3491L37.0835 78.9887C37.5231 79.4329 38.0716 79.7391 38.6691 79.8737L52.9698 83.0972C54.5361 83.4503 56.1426 82.5758 56.7771 81.007C58.0658 77.8209 60.7824 72.6861 65.5595 70.2603C66.972 69.543 67.7588 67.9159 67.4209 66.3148L60.7929 34.9067C60.6574 34.2648 60.9777 33.5972 61.5594 33.3477Z"
      fill="#5C5555"
    />
    <path
      d="M68.8816 23.5118C68.2359 28.1482 65.3045 31.7619 61.5466 33.3755C60.964 33.6259 60.6432 34.2928 60.7782 34.9353L67.409 66.3627C67.7482 67.9656 66.9602 69.594 65.5472 70.3118C60.7683 72.7382 58.0504 77.8758 56.7611 81.065C56.1261 82.6346 54.5189 83.509 52.9528 83.1559L47.502 81.927C49.0681 82.2801 50.6752 81.4056 51.3103 79.8361C52.5997 76.6471 55.3175 71.5093 60.0964 69.083C61.5094 68.365 62.2974 66.7367 61.9583 65.1338L55.3274 33.7064C55.1925 33.0639 55.5132 32.397 56.0958 32.1466C59.8537 30.533 62.7851 26.9193 63.4308 22.2829C64.1842 16.8924 61.5742 11.8143 57.1049 9.53715C58.3072 9.49972 59.5396 9.65906 60.7626 10.0381C66.3076 11.7567 69.7305 17.4352 68.8816 23.5118Z"
      fill="black"
    />
    <path
      d="M40.9765 71.6084C42.7314 70.4164 43.2602 67.9617 42.1577 66.1257C41.0552 64.2897 38.7388 63.7676 36.9839 64.9597C35.229 66.1517 34.7002 68.6064 35.8027 70.4424C36.9052 72.2784 39.2216 72.8005 40.9765 71.6084Z"
      fill="#D8C5A9"
    />
    <path
      d="M42.6946 67.6676C42.9877 69.8324 41.5619 71.8621 39.5082 72.204C38.922 72.3016 38.3468 72.2513 37.8192 72.0773C38.965 71.236 39.6322 69.7573 39.423 68.2121C39.2138 66.667 38.1848 65.4726 36.8667 65.0414C37.3249 64.7034 37.8617 64.4679 38.4476 64.3704C40.5014 64.0288 42.4019 65.5048 42.6946 67.6676Z"
      fill="#D8C5A9"
    />
    <path
      d="M45.6088 57.0856C47.3637 55.8936 47.8926 53.4389 46.79 51.6029C45.6875 49.7668 43.3711 49.2448 41.6162 50.4368C39.8613 51.6289 39.3325 54.0836 40.435 55.9196C41.5376 57.7556 43.854 58.2776 45.6088 57.0856Z"
      fill="#D8C5A9"
    />
    <path
      d="M47.3267 53.1447C47.6198 55.3094 46.194 57.3391 44.1402 57.6811C43.5541 57.7786 42.9788 57.7283 42.4513 57.5544C43.5971 56.713 44.2643 55.2343 44.0551 53.6892C43.8459 52.144 42.8169 50.9496 41.4988 50.5184C41.957 50.1805 42.4937 49.9449 43.0797 49.8474C45.1335 49.5059 47.034 50.9819 47.3267 53.1447Z"
      fill="#D8C5A9"
    />
    <path
      d="M50.2409 42.5628C51.9958 41.3707 52.5246 38.916 51.4221 37.08C50.3196 35.244 48.0032 34.722 46.2483 35.914C44.4934 37.1061 43.9646 39.5608 45.0671 41.3968C46.1696 43.2328 48.486 43.7548 50.2409 42.5628Z"
      fill="#D8C5A9"
    />
    <path
      d="M51.959 38.6218C52.2521 40.7866 50.8263 42.8163 48.7726 43.1582C48.1864 43.2558 47.6112 43.2055 47.0836 43.0316C48.2294 42.1902 48.8966 40.7115 48.6874 39.1664C48.4782 37.6212 47.4492 36.4268 46.1311 35.9956C46.5893 35.6576 47.1261 35.4221 47.712 35.3246C49.7658 34.9829 51.6661 36.459 51.959 38.6218Z"
      fill="#D8C5A9"
    />
    <path
      d="M54.8582 28.0205C56.5988 26.8351 57.1229 24.3945 56.0288 22.5693C54.9347 20.7441 52.6368 20.2253 50.8962 21.4107C49.1556 22.5961 48.6315 25.0367 49.7256 26.8619C50.8197 28.6871 53.1176 29.2059 54.8582 28.0205Z"
      fill="#D8C5A9"
    />
    <path
      d="M56.5622 24.0997C56.8533 26.2509 55.44 28.2681 53.4037 28.6082C52.8225 28.7052 52.2521 28.6554 51.729 28.4826C52.8649 27.6463 53.5262 26.1768 53.3184 24.6413C53.1107 23.1058 52.0902 21.919 50.7831 21.4906C51.2374 21.1547 51.7695 20.9206 52.3505 20.8236C54.3868 20.4838 56.2714 21.9504 56.5622 24.0997Z"
      fill="#D8C5A9"
    />
    <path
      d="M28.3248 58.4665L26.5356 63.7133C26.385 64.1549 26.0659 64.5091 25.6595 64.6864C24.5596 65.167 23.3025 65.2359 22.1058 64.7829C20.9091 64.3298 19.9811 63.4336 19.4229 62.3254C19.2166 61.9159 19.1844 61.4289 19.335 60.9873L21.1241 55.7404C21.2747 55.2988 21.5938 54.9447 22.0002 54.7673C23.1001 54.2868 24.3573 54.2179 25.5539 54.6709C26.7506 55.124 27.6786 56.0202 28.2368 57.1284C28.4432 57.5378 28.4754 58.0249 28.3248 58.4665Z"
      fill="#DEECF0"
    />
    <path
      d="M25.5552 54.6708C26.7527 55.1242 27.6795 56.0203 28.238 57.1287C28.4446 57.5378 28.4772 58.0258 28.3267 58.4669L27.1416 61.9426C27.2927 61.4999 27.2595 61.0135 27.0535 60.6028C26.495 59.4944 25.5675 58.5998 24.3702 58.1464C23.1741 57.6936 21.9171 57.7611 20.8168 58.2415C20.4098 58.4201 20.092 58.7736 19.9415 59.2147L21.1261 55.7406C21.2766 55.2994 21.5949 54.9444 22.0013 54.7674C23.1015 54.287 24.3591 54.218 25.5552 54.6708Z"
      fill="#DEECF0"
    />
    <path
      d="M33.2029 43.0505L31.4137 48.2973C31.2631 48.7389 30.9441 49.0931 30.5376 49.2704C29.4378 49.751 28.1806 49.8199 26.9839 49.3669C25.7873 48.9138 24.8592 48.0176 24.301 46.9094C24.0948 46.4999 24.0625 46.0129 24.2131 45.5713L26.0023 40.3244C26.1529 39.8828 26.4719 39.5287 26.8784 39.3513C27.9783 38.8708 29.2354 38.8019 30.4321 39.2549C31.6288 39.708 32.5568 40.6041 33.115 41.7124C33.3213 42.1219 33.3535 42.6089 33.2029 43.0505Z"
      fill="#DEECF0"
    />
    <path
      d="M30.4333 39.2548C31.6308 39.7082 32.5576 40.6042 33.1161 41.7127C33.3227 42.1218 33.3553 42.6098 33.2048 43.0509L32.0197 46.5266C32.1707 46.0839 32.1376 45.5975 31.9315 45.1868C31.3731 44.0784 30.4456 43.1838 29.2483 42.7304C28.0522 42.2776 26.7951 42.345 25.6949 42.8255C25.2879 43.0041 24.9701 43.3576 24.8196 43.7987L26.0041 40.3246C26.1546 39.8834 26.473 39.5284 26.8794 39.3514C27.9797 38.8709 29.2372 38.8019 30.4333 39.2548Z"
      fill="#DEECF0"
    />
    <path
      d="M37.2276 29.1488L35.4384 34.3956C35.2878 34.8373 34.9688 35.1914 34.5623 35.3687C33.4625 35.8493 32.2053 35.9182 31.0086 35.4652C29.812 35.0121 28.8839 34.1159 28.3257 33.0077C28.1195 32.5982 28.0872 32.1112 28.2378 31.6696L30.027 26.4227C30.1776 25.9811 30.4966 25.627 30.9031 25.4496C32.003 24.9691 33.2601 24.9002 34.4568 25.3532C35.6535 25.8063 36.5815 26.7025 37.1397 27.8107C37.346 28.2202 37.3782 28.7072 37.2276 29.1488Z"
      fill="#DEECF0"
    />
    <path
      d="M34.4581 25.3531C35.6556 25.8065 36.5824 26.7026 37.1409 27.811C37.3475 28.2201 37.3801 28.7081 37.2296 29.1492L36.0445 32.6249C36.1955 32.1822 36.1624 31.6958 35.9563 31.2851C35.3979 30.1767 34.4704 29.2821 33.2731 28.8287C32.077 28.3759 30.8199 28.4434 29.7197 28.9238C29.3127 29.1024 28.9949 29.4559 28.8444 29.897L30.0289 26.4229C30.1794 25.9818 30.4978 25.6267 30.9042 25.4497C32.0044 24.9693 33.262 24.9003 34.4581 25.3531Z"
      fill="#DEECF0"
    />
    <path
      d="M42.2639 15.4804L40.4747 20.7272C40.3241 21.1688 40.0051 21.523 39.5986 21.7003C38.4988 22.1809 37.2416 22.2498 36.0449 21.7967C34.8483 21.3437 33.9202 20.4475 33.362 19.3393C33.1557 18.9298 33.1235 18.4428 33.2741 18.0012L35.0633 12.7543C35.2139 12.3127 35.5329 11.9586 35.9394 11.7812C37.0392 11.3007 38.2964 11.2318 39.4931 11.6848C40.6897 12.1379 41.6178 13.034 42.176 14.1423C42.3822 14.5518 42.4145 15.0388 42.2639 15.4804Z"
      fill="#DEECF0"
    />
    <path
      d="M39.4942 11.6847C40.6918 12.1381 41.6186 13.0342 42.1771 14.1426C42.3837 14.5518 42.4163 15.0397 42.2658 15.4808L41.0807 18.9565C41.2317 18.5138 41.1985 18.0275 40.9925 17.6167C40.434 16.5083 39.5066 15.6137 38.3093 15.1603C37.1132 14.7075 35.8561 14.775 34.7559 15.2554C34.3488 15.434 34.0311 15.7875 33.8806 16.2286L35.0651 12.7545C35.2156 12.3134 35.534 11.9583 35.9404 11.7813C37.0407 11.3009 38.2981 11.2319 39.4942 11.6847Z"
      fill="#DEECF0"
    />
  </svg>
);

export const PitchedPercussionIcon = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z"
      fill="#A447A6"
    />
    <circle cx="64" cy="64" r="49" fill="#BB7EB5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.041 45.919V76.0069C38.041 77.2798 39.0825 78.3214 40.3555 78.3214C41.6284 78.3214 42.6699 77.2795 42.6699 76.0069V45.919H38.041ZM84.3299 45.919V58.6487C84.3299 59.921 85.3714 60.9631 86.6444 60.9631C87.9173 60.9631 88.9588 59.9213 88.9588 58.6487V45.919H84.3299ZM75.0723 45.919V62.1203C75.0723 63.3928 76.1138 64.4348 77.3867 64.4348C78.6597 64.4348 79.7012 63.393 79.7012 62.1203V45.919H75.0723ZM65.8145 45.919V65.5919C65.8145 66.8643 66.856 67.9063 68.1289 67.9063C69.4019 67.9063 70.4434 66.8645 70.4434 65.5919V45.919H65.8145ZM56.5566 45.919V69.0635C56.5566 70.3362 57.5981 71.378 58.8711 71.378C60.144 71.378 61.1855 70.3362 61.1855 69.0635V45.919H56.5566ZM47.2988 45.919V72.5352C47.2988 73.808 48.3403 74.8497 49.6133 74.8497C50.8862 74.8497 51.9277 73.8079 51.9277 72.5352V45.919H47.2988Z"
      fill="#FDEF8F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M99.5283 45.9191C100.801 45.9191 101.843 44.8776 101.843 43.6046V41.29C101.843 40.0171 100.801 38.9756 99.5283 38.9756H82.633V41.29H44.3672V38.9756H27.4717C26.199 38.9756 25.1572 40.0174 25.1572 41.29V43.6046C25.1572 44.8774 26.1987 45.9191 27.4717 45.9191H99.5283Z"
      fill="#F7BD83"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.3672 32.0322H82.633V41.29H44.3672V32.0322Z"
      fill="#FDEF8F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.8994 45.919V98.1061H99.5283V45.919H94.8994ZM32.1006 98.1061V45.919H27.4717V98.1061H32.1006Z"
      fill="#F7BD83"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.8994 45.919V49.3907H99.5283V45.919H94.8994ZM32.1006 49.3906H27.4717V45.9189H32.1006V49.3906Z"
      fill="#F3A451"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.9434 38.9756H27.4717C26.199 38.9756 25.1572 40.0174 25.1572 41.29V43.6046C25.1572 44.8774 26.1987 45.9191 27.4717 45.9191H30.9434C29.6704 45.9191 28.6289 44.8776 28.6289 43.6046V41.29C28.6289 40.0174 29.6707 38.9756 30.9434 38.9756Z"
      fill="#F3A451"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.3672 32.0322H47.8389V41.29H44.3672V32.0322Z"
      fill="#FDE21E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.041 45.9189V49.3906H42.6699V45.9189H38.041ZM84.3299 45.9189V49.3906H88.9588V45.9189H84.3299ZM75.0723 45.9189V49.3906H79.7012V45.9189H75.0723ZM65.8145 45.9189V49.3906H70.4434V45.9189H65.8145ZM56.5566 45.9189V49.3906H61.1855V45.9189H56.5566ZM47.2988 45.9189V49.3906H51.9277V45.9189H47.2988Z"
      fill="#FDE21E"
    />
    <path d="M64.6572 35.3663H66.9717V37.6808H64.6572V35.3663Z" fill="black" />
    <path d="M60.0283 35.3663H62.3428V37.6808H60.0283V35.3663Z" fill="black" />
    <path d="M98.3711 87.6912H100.686V90.0056H98.3711V87.6912Z" fill="black" />
    <path
      d="M99.5283 37.8185H83.79V30.875H43.21V37.8185H33.2578V40.133H43.21V42.4474H83.79V40.133H99.5283C100.166 40.133 100.686 40.652 100.686 41.2902V43.6046C100.686 44.2428 100.166 44.7619 99.5283 44.7619H27.4717C26.8337 44.7619 26.3145 44.2428 26.3145 43.6046V41.2902C26.3145 40.652 26.8337 40.133 27.4717 40.133H30.9434V37.8185H27.4717C25.5573 37.8185 24 39.376 24 41.2902V43.6046C24 45.1132 24.9676 46.3996 26.3145 46.8773V99.2635H33.2578V47.0763H36.8838V76.007C36.8838 77.9212 38.4411 79.4785 40.3555 79.4785C42.2698 79.4785 43.8271 77.9212 43.8271 76.007V47.0763H46.1416V72.5353C46.1416 74.4495 47.6989 76.007 49.6133 76.007C51.5276 76.007 53.085 74.4495 53.085 72.5353V47.0763H55.3994V69.0636C55.3994 70.9778 56.9567 72.5353 58.8711 72.5353C60.7855 72.5353 62.3428 70.9778 62.3428 69.0636V47.0763H64.6572V65.592C64.6572 67.5062 66.2145 69.0636 68.1289 69.0636C70.0433 69.0636 71.6006 67.5062 71.6006 65.592V47.0763H73.915V62.1204C73.915 64.0346 75.4724 65.5921 77.3867 65.5921C79.3011 65.5921 80.8584 64.0346 80.8584 62.1204V47.0763H83.1729V58.6487C83.1729 60.563 84.7302 62.1204 86.6445 62.1204C88.5589 62.1204 90.1162 60.563 90.1162 58.6487V47.0763H93.7422V99.2635H100.686V92.3202H98.3711V96.9491H96.0566V47.0763H98.3711V85.3768H100.686V46.8773C102.032 46.3996 103 45.1132 103 43.6046V41.2902C103 39.3758 101.443 37.8185 99.5283 37.8185ZM81.4756 40.133H45.5244V33.1895H81.4756V40.133ZM30.9434 96.9489H28.6289V47.0763H30.9434V96.9489ZM41.5127 76.007C41.5127 76.645 40.9935 77.1641 40.3555 77.1641C39.7175 77.1641 39.1982 76.645 39.1982 76.007V47.0763H41.5127V76.007ZM50.7705 72.5353C50.7705 73.1735 50.2513 73.6925 49.6133 73.6925C48.9753 73.6925 48.4561 73.1735 48.4561 72.5353V47.0763H50.7705V72.5353ZM60.0283 69.0636C60.0283 69.7018 59.5093 70.2209 58.8711 70.2209C58.2329 70.2209 57.7139 69.7018 57.7139 69.0636V47.0763H60.0283V69.0636ZM69.2861 65.592C69.2861 66.2301 68.7669 66.7492 68.1289 66.7492C67.4909 66.7492 66.9717 66.2301 66.9717 65.592V47.0763H69.2861V65.592ZM78.5439 62.1204C78.5439 62.7586 78.0247 63.2777 77.3867 63.2777C76.7487 63.2777 76.2295 62.7586 76.2295 62.1204V47.0763H78.5439V62.1204ZM87.8018 58.6487C87.8018 59.2869 87.2825 59.806 86.6445 59.806C86.0065 59.806 85.4873 59.2869 85.4873 58.6487V47.0763H87.8018V58.6487Z"
      fill="black"
    />
  </svg>
);

export const VocalsIcon = () => (
  <svg
    height={SIZE}
    strokeMiterlimit="10"
    version="1.1"
    viewBox="0 0 128 128"
    width={SIZE}
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs />
    <g id="Ohne-Titel">
      <path
        d="M28.0986 79.3212L100.901 79.3212L100.901 101.705L28.0986 101.705L28.0986 79.3212Z"
        fill="#ffffff"
        fillRule="nonzero"
        opacity="1"
        stroke="none"
      />
      <g opacity="1">
        <path
          d="M64 128.5C99.3462 128.5 128 99.8462 128 64.5C128 29.1538 99.3462 0.5 64 0.5C28.6538 0.5 0 29.1538 0 64.5C0 99.8462 28.6538 128.5 64 128.5Z"
          fill="#b25f5f"
          fillRule="nonzero"
          opacity="1"
          stroke="none"
        />
        <g opacity="1">
          <clipPath clipRule="nonzero" id="ClipPath">
            <path d="M64 128.5C99.3462 128.5 128 99.8462 128 64.5C128 29.1538 99.3462 0.5 64 0.5C28.6538 0.5 0 29.1538 0 64.5C0 99.8462 28.6538 128.5 64 128.5Z" />
          </clipPath>
          <g clipPath="url(#ClipPath)">
            <path
              d="M90.3927 73.4215C93.548 71.6383 95.6795 68.2552 95.6795 64.3722C95.6795 59.9327 92.894 56.1458 88.9765 54.658L88.9765 51.6362C88.9762 37.754 77.7222 26.5 63.8397 26.5C54.7007 26.5 46.7015 31.3775 42.3018 38.671C38.5738 40.5902 36.022 44.4735 36.022 48.9552C36.022 51.2 36.6637 53.294 37.7707 55.0678C34.3512 56.7683 32 60.2942 32 64.3722C32 68.255 34.1315 71.6383 37.2867 73.4215C34.1315 75.2048 32 78.5877 32 82.4707C32 88.209 36.6517 92.8605 42.3897 92.8605C46.7017 92.8605 50.3997 90.2333 51.9717 86.4925L75.7072 86.4925C77.2792 90.2333 80.9772 92.8605 85.2892 92.8605C91.0275 92.8605 95.679 88.2087 95.679 82.4707C95.6795 78.588 93.548 75.2048 90.3927 73.4215Z"
              fill="#000000"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M62.3752 85.5C65.3256 85.5 67.9592 87.3498 68.9601 90.1252L82.1614 126.729C82.704 128.234 82.715 129.879 82.1925 131.391L68.9211 169.787C67.9461 172.608 65.2898 174.5 62.3052 174.5L43.0003 174.5C39.1342 174.5 36.0001 171.384 36.0003 167.518C36.0009 152.6 36.0023 117.295 36.0023 96.6101C36.0023 90.4741 40.1702 85.5 45.314 85.5L62.3752 85.5Z"
              fill="#1f0f0f"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M64.3159 99.5L70 125.102L64.3159 163.5L49 99.5L64.3159 99.5Z"
              fill="#ffffff"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M65.2198 80.5L70 95.9326L65.2198 109.5C61.3209 109.479 57.4288 107.977 54.6189 104.995L49 99.0252L52.1848 99.0252C54.1522 99.0252 55.7446 97.5432 55.7446 95.7122L55.7446 80.5L65.2198 80.5Z"
              fill="#f99569"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M80 99.0247L74.8519 104.994C72.246 108.018 68.6185 109.52 65 109.5L65 80.5L73.8224 80.5L73.8224 95.7126C73.8224 97.5436 75.2812 99.0256 77.0834 99.0256L80 99.0247Z"
              fill="#130301"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M64.7878 33.5C54.2451 33.5 45.5762 41.7975 44.4836 52.4504C43.5038 50.7233 41.701 49.5603 39.6324 49.5603C36.5221 49.5603 34 52.1807 34 55.4143L34 59.2006C34 64.3014 37.9789 68.4359 42.8856 68.4359L44.9707 68.4359C47.1914 77.6627 55.2184 84.5 64.7869 84.5L75 62.9775L64.7878 33.5Z"
              fill="#ffc0a4"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M34.4854 52.8318L34.5987 52.5488C34.9222 51.7399 35.4327 51.0191 36.0884 50.4454C38.0506 48.7284 40.9469 48.6193 43.0328 50.1837L44.5455 51.3182L43.8182 61.6818L43.8182 64.2321C43.8182 64.7106 43.8953 65.186 44.0467 65.64L45.3624 69.5872C45.6761 70.5282 44.9756 71.5 43.9837 71.5C43.8737 71.5 43.7641 71.4875 43.6569 71.4628L42.6213 71.2238C38.9602 70.3789 36.0026 67.6896 34.8144 64.1251L34.612 63.5179C34.2067 62.3018 34 61.0283 34 59.7464L34 58.9545L34 55.3526C34 54.4891 34.1648 53.6336 34.4854 52.8318Z"
              fill="#000000"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M89 54.5C86.9169 54.5 86.4298 50.7246 85.4442 52.4526C84.9344 47.5013 82.7789 43.0572 79.5433 39.7194C75.8226 35.8753 70.679 33.5 65 33.5L65 84.5C74.6325 84.5 82.7147 77.6635 84.9509 68.4356L87.0523 68.4356C91.9942 68.4356 91 63.7998 93.5 58.5L93.5 56C93.5009 52.7691 89 56.0474 89 54.5Z"
              fill="#ffa87a"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M84.9158 56.4976C83.1071 56.425 81.3547 55.9943 79.7324 55.2369C78.1135 54.4805 76.6255 53.4032 75.3453 52.0355C74.024 50.6259 72.9901 48.9861 72.2797 47.2001C70.0016 49.0902 67.5604 50.7118 65 52.0451L65 30.5C69.215 30.5 73.2544 31.6967 76.7805 33.9392L77.095 33.603L77.095 34.1416C78.6072 35.1387 80.0235 36.3297 81.31 37.704C85.1774 41.8241 87.5505 47.2832 87.9904 53.0804C88.1319 54.9714 86.695 56.5711 84.9158 56.4976Z"
              fill="#000000"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M95 98.3855L95 174.5L65 174.5L65 86.5L86.6152 86.5L95 98.3855Z"
              fill="#000000"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M82.2878 106.827L84.7525 128.208L65.4995 150.5L46.2475 128.208L48.7122 106.827L41 106.827L44.1866 86.5028C44.2639 86.5 44.3439 86.5 44.4211 86.5L86.5789 86.5C86.6561 86.5 86.7361 86.5 86.8133 86.5028L90 106.827L82.2878 106.827Z"
              fill="#000000"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M84.9158 57.4976C83.1071 57.425 81.3547 56.9943 79.7324 56.2369C78.1135 55.4805 76.6255 54.4032 75.3453 53.0355C74.024 51.6259 72.9901 49.986 72.2797 48.2001C70.0016 50.0901 67.5604 51.7118 65 53.0451L65 31.5C69.215 31.5 73.2544 32.6967 76.7805 34.9392L77.095 34.603L77.095 35.1416C78.6072 36.1387 80.0235 37.3297 81.31 38.704C85.1774 42.8241 87.5505 48.2832 87.9904 54.0804C88.1319 55.9714 86.695 57.5711 84.9158 57.4976Z"
              fill="#000000"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M84.9681 86.5346C83.9315 86.3501 82.9026 86.913 82.354 87.9889L60.788 130.198L58.662 134.359C58.3624 134.946 57.7219 135.109 57.2523 134.725L51.5081 130.01C49.5998 128.444 47.0073 127.998 44.6856 128.838L42.6189 129.586C39.8468 130.588 38 133.22 38 136.168L38 141.994C38 144.089 38.9389 146.075 40.5587 147.404L50.1272 155.258C52.7183 157.383 55.7866 158.5 58.8834 158.5C59.5185 158.5 60.1536 158.454 60.7888 158.359C61.2385 158.291 61.6882 158.202 62.1326 158.085C66.2628 157.009 69.9004 153.894 72.1031 149.561L93.2194 108.179C97.7557 99.2902 93.1251 87.9954 84.9681 86.5346Z"
              fill="#000000"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M47.9204 98.9624L47.5497 98.5L47 99.0413L47 143.629C47.7043 143.938 48.4156 144.228 49.1333 144.5L49.1333 99.182C48.7432 99.442 48.2494 99.3728 47.9204 98.9624Z"
              fill="#b5adb6"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M50.7737 98.9179C50.5847 99.1169 50.3337 99.2266 50.0667 99.2266C49.7997 99.2266 49.5484 99.1169 49.3594 98.9179L48.7527 98.2781L48.0667 98.8493L48.0667 144.891C49.7032 145.499 51.3699 146.039 53.0667 146.5L53.0667 96.5L50.7737 98.9179Z"
              fill="#cbc4cc"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M67.3812 73.1186C63.8897 69.6271 58.229 69.6271 54.7377 73.1186C52.5881 75.2683 51.7642 78.2397 52.2614 81.0214L59.4785 88.2385C62.2602 88.7357 65.2316 87.9118 67.3812 85.7621C70.8728 82.2709 70.8728 76.6099 67.3812 73.1186Z"
              fill="#807d80"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M56.6247 72.1753L60.2077 75.7583C62.565 73.9238 65.628 73.4317 68.3634 74.287C68.0739 73.8774 67.748 73.4856 67.3811 73.1189C64.363 70.1008 59.7252 69.6941 56.2676 71.8937C56.3943 71.9724 56.5147 72.065 56.6247 72.1753Z"
              fill="#b5adb6"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M52.355 80.7374L57.1898 85.5721C56.4809 83.3798 56.6363 80.9693 57.6643 78.8757L53.7943 75.0057C53.6844 74.8958 53.5915 74.7754 53.5125 74.6489C52.3665 76.4503 51.9299 78.572 52.1995 80.6181C52.2544 80.6512 52.3073 80.6897 52.355 80.7374Z"
              fill="#b5adb6"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M67.2867 87.6695C66.7746 87.6695 66.2622 87.4742 65.8712 87.0832L53.7938 75.0057C53.0121 74.2241 53.0121 72.9567 53.7938 72.1752C54.5757 71.3936 55.8429 71.3936 56.6245 72.1752L68.702 84.2527C69.4837 85.0344 69.4837 86.3018 68.702 87.0832C68.3113 87.4739 67.7989 87.6695 67.2867 87.6695Z"
              fill="#ffffff"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M58.5236 76.9862C59.1975 76.3126 60.2009 76.1733 61.0136 76.564L56.6245 72.1752C55.8426 71.3936 54.5755 71.3936 53.7938 72.1752C53.0121 72.9569 53.0121 74.2243 53.7938 75.0057L57.9917 79.2037C57.7478 78.4482 57.9237 77.5864 58.5236 76.9862Z"
              fill="#dff6fd"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M59.7626 88.1448L52.3552 80.7374C52.0163 80.3985 51.4577 80.4313 51.1607 80.8073L46.1565 87.1445L53.3029 94.2909C53.3205 94.3086 53.3336 94.3294 53.3496 94.3478L59.6927 89.3391C60.0687 89.0423 60.1015 88.4837 59.7626 88.1448Z"
              fill="#685e68"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M42.3262 91.9952L37.1723 98.5222C36.9207 98.8409 36.9474 99.2975 37.2345 99.5846L40.9155 103.266C41.2027 103.553 41.6593 103.58 41.978 103.328L48.5049 98.1739L42.3262 91.9952Z"
              fill="#685e68"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M48.6993 88.9702L50.775 86.8945C51.222 86.4475 51.8278 86.2572 52.411 86.3215L54.8502 83.2324L52.3552 80.7374C52.0163 80.3985 51.4577 80.4313 51.1607 80.8073L46.323 86.9337L48.5405 89.1512C48.5896 89.0887 48.6416 89.0279 48.6993 88.9702Z"
              fill="#554e56"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M42.7767 98.5223L45.2915 95.3376L42.16 92.2061L37.1726 98.5223C36.9209 98.8409 36.9476 99.2975 37.2348 99.5847L40.9158 103.266C41.2029 103.553 41.6596 103.58 41.9782 103.328L44.5509 101.296L42.8392 99.5847C42.5517 99.2975 42.525 98.8409 42.7767 98.5223Z"
              fill="#554e56"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M50.828 92.3248C50.9775 92.2374 51.1196 92.1317 51.2479 92.0034L53.3939 89.8574C54.202 89.0493 54.202 87.739 53.3939 86.9309C52.5858 86.1228 51.2755 86.1228 50.4674 86.9309L48.3214 89.0769C48.1931 89.2052 48.0875 89.3473 48 89.4968L50.828 92.3248Z"
              fill="#b5adb6"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M48.7736 98.8201L41.587 91.6334C41.0657 91.1122 41.0657 90.2675 41.587 89.7463L44.4177 86.9156C44.9389 86.3944 45.7836 86.3944 46.3048 86.9156L53.4915 94.1023C54.0127 94.6235 54.0127 95.4681 53.4915 95.9893L50.6607 98.8201C50.1398 99.3413 49.2948 99.3413 48.7736 98.8201Z"
              fill="#554e56"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M44.7571 96.8149L47.4606 94.1114C47.8364 93.7357 48.3878 93.6444 48.8498 93.8359L45.7164 90.7024C45.2281 90.2142 44.4369 90.2142 43.9486 90.7024L41.2969 93.3542C40.8086 93.8424 40.8086 94.6337 41.2969 95.1219L44.6001 98.4252C44.2674 97.9299 44.3191 97.2529 44.7571 96.8149Z"
              fill="#433f43"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
            <path
              d="M49.342 39.3075C46.6322 41.8128 44.4459 44.761 42.8664 47.9994C41.2858 51.2333 40.3086 54.762 40.0126 58.4238C39.8343 60.6207 41.5772 62.5 43.791 62.5L46.0379 62.5C51.9676 62.5 57.7489 61.5414 63.2037 59.6972C67.2614 58.3252 70.2687 55.0067 71.9434 51.0642L72.8359 48.9632C74.2146 45.7175 74.1649 42.0416 72.6988 38.8344C70.6562 34.366 66.1124 31.266 61.3802 32.587C56.9272 33.8301 52.8028 36.114 49.342 39.3075Z"
              fill="#000000"
              fillRule="nonzero"
              opacity="1"
              stroke="none"
            />
          </g>
        </g>
        <path
          d="M89 64.5C92.3137 64.5 95 61.1421 95 57C95 52.8579 92.3137 49.5 89 49.5C85.6863 49.5 83 52.8579 83 57C83 61.1421 85.6863 64.5 89 64.5Z"
          fill="#000000"
          fillRule="nonzero"
          opacity="1"
          stroke="none"
        />
        <path
          d="M90 75.5C92.7614 75.5 95 72.1421 95 68C95 63.8579 92.7614 60.5 90 60.5C87.2386 60.5 85 63.8579 85 68C85 72.1421 87.2386 75.5 90 75.5Z"
          fill="#000000"
          fillRule="nonzero"
          opacity="1"
          stroke="none"
        />
      </g>
    </g>
  </svg>
);

export const MultiInstrumentsIcon = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 128 129"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4_461)">
      <g clipPath="url(#clip1_4_461)">
        <path
          d="M119.58 32.9375C119.58 46.6575 114.02 59.0775 105.03 68.0675C96.0399 77.0575 83.6199 82.6175 69.8999 82.6175H58.0999C30.6624 82.6175 8.41992 60.375 8.41992 32.9375C19.4499 13.67 40.2099 0.6875 63.9999 0.6875C87.7899 0.6875 108.55 13.67 119.58 32.9375Z"
          fill="#47B3E5"
        />
        <path
          d="M128 64.6875C128 78.565 123.582 91.4125 116.075 101.897C115.48 102.728 114.868 103.545 114.232 104.345C114.158 104.443 114.082 104.537 114.005 104.632C102.77 118.677 85.7425 127.888 66.54 128.635C65.6975 128.67 64.85 128.688 64 128.688C43.765 128.688 25.7225 119.295 13.995 104.632C13.9175 104.537 13.8425 104.443 13.7675 104.345C12.92 103.278 12.1075 102.18 11.33 101.055C4.1875 90.7275 0 78.1975 0 64.6875C0 53.1325 3.0625 42.295 8.42 32.9375C19.45 52.205 40.21 65.1875 64 65.1875C83.52 65.1875 101.003 56.4475 112.738 42.665C113.208 42.1175 113.663 41.565 114.105 41.0025C114.765 40.175 115.405 39.3325 116.018 38.4725C117.3 36.695 118.488 34.8475 119.58 32.9375C120.607 34.73 121.55 36.5775 122.4 38.4725C122.605 38.925 122.803 39.38 122.995 39.84C126.218 47.4775 128 55.875 128 64.6875Z"
          fill="#289CEA"
        />
        <path
          d="M29.7617 42.8428L42.548 51.0043"
          stroke="#3D1237"
          strokeWidth="20.557"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M24.3773 60.7997L27.3846 65.9137L24.3773 71.2902H21.4101V100.04L17.7388 102.896L14.2773 100.04V64.001L24.3773 60.7997Z"
          fill="#602558"
        />
        <path
          d="M34.5174 64.001V100.04L30.8139 103.53L27.3847 100.04V71.2902H24.3774V60.7997L24.3974 60.7932L34.5174 64.001Z"
          fill="#501845"
        />
        <path
          d="M21.4101 100.04V104.632H15.0476L13.7676 104.345C12.9201 103.277 12.1076 102.18 11.3301 101.055C12.3351 100.552 13.4226 100.217 14.2776 100.04H21.4101Z"
          fill="#3D1237"
        />
        <path
          d="M24.3773 62.523L27.3846 65.1773L24.3773 67.8313H14.2773V64.001L24.3773 62.523Z"
          fill="#501845"
        />
        <path
          d="M34.5174 64.001V67.8313H24.3774V62.523L24.3974 62.5198L34.5174 64.001Z"
          fill="#3D1237"
        />
        <path
          d="M24.3773 39.9308L29.7616 50.6498L24.3773 64.001H14.2773V43.8995C14.2773 42.0295 15.5703 40.462 17.3118 40.0418C17.6111 39.9688 17.9243 39.9308 18.2461 39.9308H24.3773Z"
          fill="#602558"
        />
        <path
          d="M34.5174 44.387V64.001H24.3774V39.9308H30.0612C30.0819 39.9308 30.1034 39.9308 30.1242 39.9315C32.5562 39.9648 34.5174 41.9465 34.5174 44.387Z"
          fill="#501845"
        />
        <path
          d="M28.908 45.452L29.5702 51.2593L24.397 57.3143L19.224 51.2593L19.8862 45.452H17.814L18.6702 39.9315C18.691 39.9308 18.7125 39.9308 18.7332 39.9308H30.061C30.0817 39.9308 30.1032 39.9308 30.124 39.9315L30.9802 45.452H28.908Z"
          fill="#3D1237"
        />
        <path
          d="M24.3774 39.9308L25.6037 46.3773L24.3774 57.2323L20.1809 39.9308H24.3774Z"
          fill="white"
        />
        <path
          d="M28.6139 39.9308L24.3974 57.3143L24.3774 57.2323V39.9308H28.6139Z"
          fill="#DFF6F0"
        />
        <path
          d="M36.0019 63.548L44.1771 85.2002L36.0019 104.639H28.6976C23.7351 104.639 19.6819 100.641 19.6519 95.6785C19.6519 95.6452 19.6511 95.6115 19.6511 95.5782C19.6511 92.4217 20.5454 89.475 22.0946 86.976C23.7856 84.249 24.4794 81.0145 23.9406 77.8515C23.8264 77.1792 23.7666 76.488 23.7666 75.7835C23.7666 69.026 29.2449 63.548 36.0019 63.548Z"
          fill="#E05E05"
        />
        <path
          d="M52.3525 95.578V95.6782C52.3227 100.641 48.2692 104.638 43.3067 104.638H36.0017V63.548H36.083C36.1152 63.548 36.1485 63.5487 36.1807 63.5487C42.9162 63.645 48.2752 69.104 48.2377 75.8527C48.2335 76.5307 48.1747 77.1965 48.0645 77.8445C47.5347 80.962 48.1292 84.1657 49.8217 86.8362C51.425 89.3645 52.3525 92.3627 52.3525 95.578Z"
          fill="#BC4D02"
        />
        <path
          d="M24.3774 34.7807L26.1214 38.8117L24.3774 42.8427C23.3687 42.837 22.3617 42.4192 21.6347 41.5902L20.1809 39.9307H21.0049C21.5139 39.9307 21.9259 39.5187 21.9259 39.0097V34.7807H24.3774Z"
          fill="#F99569"
        />
        <path
          d="M28.6139 39.9308L27.1599 41.5903C26.4239 42.4308 25.3994 42.8485 24.3774 42.8428V34.781H26.8692V39.01C26.8692 39.519 27.2812 39.931 27.7902 39.931L28.6139 39.9308Z"
          fill="#E57870"
        />
        <path
          d="M36.0018 22.651L37.3646 63.1525L36.0018 94.8408H33.4456V22.651H36.0018Z"
          fill="#3D1237"
        />
        <path d="M36.0017 22.651H38.559V94.8408H36.0017V22.651Z" fill="#2D0C2A" />
        <path
          d="M36.0019 92.9695L38.8409 94.6612L36.0019 96.353H30.6829V92.9695H36.0019Z"
          fill="#3D1237"
        />
        <path
          d="M36.0019 13.935L38.5591 20.726L36.0019 27.5612H33.3064C32.7956 27.5612 32.3821 27.1477 32.3821 26.638V25.179C32.3821 24.288 32.2719 23.4002 32.0531 22.5365L30.9249 18.0845C30.3919 15.979 31.9834 13.935 34.1544 13.935H36.0019Z"
          fill="#E05E05"
        />
        <path
          d="M18.8026 28.852C18.5338 28.3955 18.0386 28.0882 17.4706 28.0882C16.6166 28.0882 15.9241 28.7805 15.9241 29.6347V30.635C15.9241 31.9825 17.0163 33.0747 18.3638 33.0747H18.9366C19.5463 35.5122 21.7503 37.3182 24.3773 37.3182L26.4956 30.5817L24.3773 23.8452C21.4826 23.8452 19.1021 26.0372 18.8026 28.852Z"
          fill="#FFC0A4"
        />
        <path
          d="M31.2839 28.0882C30.7159 28.0882 30.2209 28.3952 29.9522 28.8517C29.8132 27.5437 29.2254 26.3697 28.3432 25.4882C27.3287 24.4727 25.9262 23.8452 24.3777 23.8452V37.318C27.0042 37.318 29.2079 35.512 29.8177 33.0745H30.3904C31.7379 33.0745 32.8302 31.9822 32.8302 30.6347V29.6345C32.8304 28.7805 32.1379 28.0882 31.2839 28.0882Z"
          fill="#FFA87A"
        />
        <path
          d="M20.0017 24.7312C19.409 25.2815 18.9307 25.929 18.5852 26.6402C18.2397 27.3505 18.0257 28.1257 17.961 28.9297C17.922 29.4122 18.3032 29.825 18.7875 29.825H19.279C21.0752 29.825 22.8092 29.4212 24.3775 28.6562L26.1215 25.6752L24.3775 23.0165C22.7495 23.0162 21.1952 23.6255 20.0017 24.7312Z"
          fill="#501845"
        />
        <path
          d="M28.9612 59.893L29.4555 64.001L25.6672 64.2645C25.5445 64.1782 25.4227 64.0905 25.3017 64.001C21.9472 61.5357 19.3022 58.232 17.6295 54.4097L13.6807 45.666C12.4897 43.0287 14.4185 40.0417 17.312 40.0417L22.641 52.2157C23.997 55.3132 26.1817 57.9682 28.9612 59.893Z"
          fill="#501845"
        />
        <path
          d="M35.9835 68.0875C35.4522 68.8535 34.5992 69.2645 33.7322 69.2645C33.1952 69.2645 32.6522 69.107 32.1772 68.778L25.8452 64.3898C25.7855 64.3483 25.726 64.3068 25.667 64.2645L28.961 59.893L34.517 63.7433L35.2927 64.2813C36.5347 65.1415 36.844 66.8458 35.9835 68.0875Z"
          fill="#FFC0A4"
        />
        <path
          d="M41.8663 43.8322L41.1828 47.506L37.3645 46.323L34.2113 39.9512C33.5823 38.6797 34.1028 37.138 35.375 36.5087C36.6465 35.8787 38.1883 36.4002 38.8175 37.6717L41.8663 43.8322Z"
          fill="#FFC0A4"
        />
        <path
          d="M43.688 53.3075C43.3218 53.489 42.933 53.5745 42.55 53.5745C41.6035 53.5745 40.6933 53.0498 40.2448 52.1438L37.3643 46.3233L41.866 43.8325L44.8508 49.8653C45.4803 51.1365 44.9598 52.6783 43.688 53.3075Z"
          fill="#602558"
        />
        <path
          d="M29.9352 29.8215C29.4304 29.8025 28.9414 29.6897 28.4887 29.4915C28.0369 29.2935 27.6217 29.0115 27.2644 28.6535C26.8957 28.2847 26.6072 27.8552 26.4089 27.3877C25.7732 27.8825 25.0919 28.307 24.3772 28.656V23.0162C25.5534 23.0162 26.6807 23.3295 27.6647 23.9165L27.7524 23.8287V23.9697C28.1744 24.2307 28.5697 24.5425 28.9287 24.9022C30.0079 25.9805 30.6702 27.4097 30.7929 28.9272C30.8329 29.422 30.4317 29.8407 29.9352 29.8215Z"
          fill="#3D1237"
        />
        <path
          d="M41.0787 18.0622L39.9515 22.5142C39.7327 23.378 39.6215 24.2657 39.6215 25.1567V26.6377C39.6215 27.1475 39.2077 27.561 38.698 27.561L36.0015 27.539V13.913H37.8492C40.021 13.913 41.6125 15.957 41.0787 18.0622Z"
          fill="#BC4D02"
        />
        <path d="M36.0017 92.9695H41.6797V96.353H36.0017V92.9695Z" fill="#2D0C2A" />
        <path
          d="M81.8946 56.7307L76.9876 67.9465C76.8816 68.1892 76.7646 68.4272 76.6379 68.6577C75.3921 70.9347 73.2021 72.5892 70.6459 73.1495L69.4149 73.409L65.6501 70.7225L67.9446 67.7037L69.3861 67.4005C70.3676 67.1857 71.1931 66.5077 71.5959 65.5877L75.5466 56.6395C76.2876 54.9612 77.9491 53.8787 79.7836 53.8787H81.6196C82.1791 54.69 82.3174 55.7617 81.8946 56.7307Z"
          fill="#501845"
        />
        <path
          d="M86.7379 53.8785L91.8079 65.658L86.7379 77.9487H76.6379C76.6379 77.9487 76.6387 64.1137 76.6387 56.8832C76.6387 55.2237 77.9839 53.8785 79.6442 53.8785H86.7379Z"
          fill="#602558"
        />
        <path
          d="M96.8775 57.1295V77.9487H86.7378V53.8785H94.0435L96.8775 57.1295Z"
          fill="#501845"
        />
        <path
          d="M96.8775 56.7125V57.1295L94.0435 53.8785C95.6085 53.8785 96.8775 55.1475 96.8775 56.7125Z"
          fill="#501845"
        />
        <path
          d="M91.2688 59.3995L91.9311 65.2067L86.7578 71.2617L81.5848 65.2067L82.2471 59.3995H80.1748L81.0311 53.879C81.0518 53.8782 81.0733 53.8782 81.0941 53.8782H92.4218C92.4426 53.8782 92.4641 53.8782 92.4848 53.879L93.3411 59.3995H91.2688Z"
          fill="#3D1237"
        />
        <path
          d="M86.7378 53.8785L88.2953 60.7997L86.7378 71.18L82.541 53.8785H86.7378Z"
          fill="white"
        />
        <path d="M90.9743 53.8785L86.7575 71.262L86.7378 71.18V53.8785H90.9743Z" fill="#DFF6F0" />
        <path
          d="M86.7378 48.7288L87.9745 53.019L86.7378 56.7908C85.729 56.785 84.722 56.3673 83.995 55.5383L82.5413 53.8788H83.3653C83.8743 53.8788 84.2863 53.4668 84.2863 52.9578V48.7288H86.7378Z"
          fill="#F99569"
        />
        <path
          d="M90.9743 53.8785L89.5203 55.538C88.7843 56.3785 87.7598 56.7963 86.7378 56.7905V48.7288H89.2295V52.9578C89.2295 53.4668 89.6415 53.8788 90.1505 53.8788L90.9743 53.8785Z"
          fill="#E57870"
        />
        <path
          d="M86.7379 37.793C83.8432 37.793 81.4629 39.985 81.1629 42.7993C80.8939 42.343 80.3989 42.0358 79.8309 42.0358C78.9769 42.0358 78.2844 42.728 78.2844 43.5822V44.5825C78.2844 45.93 79.3769 47.0223 80.7242 47.0223H81.2967C81.9064 49.4598 84.1104 51.266 86.7377 51.266L89.5419 45.5802L86.7379 37.793Z"
          fill="#FFC0A4"
        />
        <path
          d="M93.6443 42.0357C93.0763 42.0357 92.581 42.343 92.3123 42.7995C92.1733 41.4915 91.5855 40.3175 90.7033 39.4357C89.6888 38.4202 88.2863 37.7927 86.7378 37.7927V51.2655C89.3643 51.2655 91.568 49.4595 92.1778 47.0217H92.7508C94.0983 47.0217 95.1905 45.9295 95.1905 44.582V43.5817C95.1908 42.7282 94.4983 42.0357 93.6443 42.0357Z"
          fill="#FFA87A"
        />
        <path
          d="M82.3621 38.6792C81.7693 39.2295 81.2911 39.877 80.9456 40.5882C80.5999 41.2985 80.3861 42.0735 80.3214 42.8777C80.2824 43.3602 80.6636 43.773 81.1479 43.773H81.6394C83.4356 43.773 85.1696 43.3692 86.7378 42.6042L87.9746 39.681L86.7378 36.9645C85.1098 36.9642 83.5556 37.5735 82.3621 38.6792Z"
          fill="#501845"
        />
        <path
          d="M92.2955 43.7692C91.7908 43.7502 91.3018 43.6375 90.849 43.4392C90.3973 43.2412 89.982 42.9592 89.6248 42.6012C89.256 42.2322 88.9675 41.803 88.7693 41.3355C88.1335 41.8302 87.4523 42.2547 86.7378 42.6037V36.964C87.914 36.964 89.0413 37.2772 90.0253 37.8642L90.113 37.7762V37.9172C90.535 38.1782 90.9303 38.49 91.2893 38.8497C92.3685 39.9282 93.0308 41.3572 93.1535 42.8747C93.193 43.3697 92.792 43.7885 92.2955 43.7692Z"
          fill="#3D1237"
        />
        <path
          d="M94.628 53.9207C94.2898 53.871 93.954 54.0227 93.775 54.3127L86.7378 65.6902L86.044 66.8117C85.9463 66.97 85.7373 67.014 85.584 66.9105L82.7053 64.9585L79.3018 65.9755V69.762L83.259 72.4452C84.1045 73.018 85.1058 73.319 86.1163 73.319C86.3235 73.319 86.5308 73.3065 86.738 73.281C86.8848 73.2627 87.0315 73.2387 87.1765 73.2072C88.5243 72.917 89.7113 72.0775 90.43 70.9095L97.3205 59.755C98.8008 57.359 97.2898 54.3145 94.628 53.9207Z"
          fill="#3D1237"
        />
        <path
          d="M75.1912 42.9487L76.046 52.4902L75.1912 62.359H73.8235V42.9487H75.1912Z"
          fill="#E05E05"
        />
        <path d="M75.1914 42.9487H76.5592V62.359H75.1914V42.9487Z" fill="#BC4D02" />
        <path
          d="M62.7066 73.9975L61.4938 74.6307L52.5178 57.4205L53.7303 56.788L59.3018 65.9132L62.7066 73.9975Z"
          fill="#E05E05"
        />
        <path
          d="M53.7273 56.8311L54.9405 56.1992L63.9078 73.4157L62.6946 74.0476L53.7273 56.8311Z"
          fill="#BC4D02"
        />
        <path
          d="M82.7053 64.9583L79.3018 69.7618L73.3515 65.7143C72.0063 64.8025 71.6555 62.9723 72.5673 61.6278C73.479 60.2825 75.3093 59.931 76.6545 60.8438L82.7053 64.9583Z"
          fill="#FFC0A4"
        />
        <path
          d="M69.4147 73.409L61.1665 75.1447C60.9542 75.1912 60.743 75.2135 60.534 75.2135C59.1812 75.2135 57.9635 74.2752 57.6627 72.9C57.3145 71.3127 58.3192 69.7435 59.9075 69.3955L67.9445 67.7037L69.4147 73.409Z"
          fill="#FFC0A4"
        />
        <path
          d="M96.8778 77.9487V85.7627H74.0576C72.8566 85.7627 71.8833 86.7367 71.8833 87.9377V100.04L67.7861 102.336L64.0876 100.04C64.0818 100.042 64.0761 100.043 64.0693 100.045V85.763C64.0693 83.6055 64.9438 81.6517 66.3578 80.2375C67.7718 78.8235 69.7256 77.949 71.8833 77.949L96.8778 77.9487Z"
          fill="#501845"
        />
        <path d="M86.7378 77.9487H96.8778V85.7627H86.7378V77.9487Z" fill="#3D1237" />
        <path
          d="M96.8777 81.8562V100.045C96.871 100.043 96.8652 100.042 96.8595 100.04L92.9707 102.749L89.0637 100.04V81.8562C89.0637 80.777 89.5005 79.7997 90.2077 79.0935C90.9147 78.3857 91.8912 77.9487 92.9705 77.9487C95.1287 77.9487 96.8777 79.6977 96.8777 81.8562Z"
          fill="#501845"
        />
        <path
          d="M71.8833 100.04V104.632H60.0036C58.9401 104.632 58.3716 103.385 59.0646 102.579C60.2666 101.182 62.5376 100.368 64.0693 100.044C64.0761 100.043 64.0818 100.042 64.0876 100.04L71.8833 100.04Z"
          fill="#3D1237"
        />
        <path
          d="M100.943 104.632H89.0637V100.04H96.8595C96.8652 100.042 96.871 100.043 96.8777 100.045C98.4095 100.368 100.681 101.182 101.882 102.579C102.575 103.385 102.007 104.632 100.943 104.632Z"
          fill="#3D1237"
        />
        <path d="M59.6143 74.4475H84.7173V85.398H59.6143V74.4475Z" fill="#FCA50B" />
        <path d="M72.1663 74.4475H84.7173V85.398H72.1663V74.4475Z" fill="#FF8B00" />
        <path
          d="M63.5047 85.2222L64.486 95.7262L63.5047 104.632H62.1372V85.2222H63.5047Z"
          fill="white"
        />
        <path d="M63.5046 85.2222H64.8724V104.632H63.5046V85.2222Z" fill="#DFF6F0" />
        <path
          d="M72.1658 85.2222L72.8496 95.7262L72.1658 104.632H70.7981V85.2222H72.1658Z"
          fill="white"
        />
        <path d="M72.1658 85.2222H73.5335V104.632H72.1658V85.2222Z" fill="#DFF6F0" />
        <path
          d="M80.828 85.2222L81.806 95.5925L80.828 104.632H79.4602V85.2222H80.828Z"
          fill="white"
        />
        <path d="M80.8279 85.2222H82.1956V104.632H80.8279V85.2222Z" fill="#DFF6F0" />
        <path
          d="M72.166 83.4492L73.8235 85.4277L72.166 87.1985H57.594V83.4492H72.166Z"
          fill="white"
        />
        <path d="M72.166 83.4492H86.738V87.1982H72.166V83.4492Z" fill="#DFF6F0" />
        <path
          d="M72.166 72.5735L73.896 74.4472L72.166 76.3217H57.594V72.5735H72.166Z"
          fill="white"
        />
        <path d="M72.166 72.5735H86.738V76.3217H72.166V72.5735Z" fill="#DFF6F0" />
        <path
          d="M89.064 71.2355L97.9017 88.2542L89.064 104.632C79.8417 104.632 72.366 97.1565 72.366 87.9342C72.366 78.712 79.8417 71.2355 89.064 71.2355Z"
          fill="#FEC609"
        />
        <path
          d="M105.762 87.9345C105.762 97.1567 98.2862 104.632 89.064 104.632V71.2355C98.2862 71.2355 105.762 78.7122 105.762 87.9345Z"
          fill="#FCA50B"
        />
        <path
          d="M89.0639 74.4472L94.9324 88.3065L89.0639 101.42C81.6151 101.42 75.5776 95.3822 75.5776 87.9342C75.5776 80.4857 81.6151 74.4472 89.0639 74.4472Z"
          fill="white"
        />
        <path
          d="M102.55 87.9345C102.55 95.3825 96.513 101.421 89.064 101.421V74.4472C96.5127 74.4472 102.55 80.4857 102.55 87.9345Z"
          fill="#DFF6F0"
        />
        <path
          d="M112.738 26.763L113.771 59.893L112.738 104.632H106.078V101.897H111.37V26.763H112.738Z"
          fill="white"
        />
        <path
          d="M116.075 101.897C115.48 102.727 114.868 103.545 114.233 104.345L113.338 104.632H112.738V26.7625H114.105V101.897H116.075Z"
          fill="#DFF6F0"
        />
        <path
          d="M54.828 42.9437L55.6585 72.5735L54.828 104.632H48.429V101.897H53.4602V42.9437H54.828Z"
          fill="white"
        />
        <path
          d="M112.738 34.146L114.908 36.2417L112.738 38.4727L106.192 39.3522L97.4751 38.4727V37.105H103.355C105.845 37.105 108.248 36.2977 110.304 34.8952C110.997 34.4227 111.835 34.146 112.738 34.146Z"
          fill="#FEC609"
        />
        <path
          d="M122.4 38.4725L118.72 39.3525L112.738 38.4725V34.145C113.64 34.145 114.478 34.4225 115.17 34.895C117.128 36.23 119.398 37.025 121.76 37.0975C121.98 37.5525 122.193 38.01 122.4 38.4725Z"
          fill="#FCA50B"
        />
        <path
          d="M112.738 38.4727L113.771 40.6357L112.738 42.7987C111.835 42.7987 110.997 42.5227 110.304 42.0495C108.248 40.647 105.845 39.8405 103.356 39.8405H97.4753V38.4727H112.738Z"
          fill="#FCA50B"
        />
        <path
          d="M62.1371 101.897V104.632H54.8279V42.9437H56.1956V101.897H62.1371Z"
          fill="#DFF6F0"
        />
        <path
          d="M54.8279 54.6535L55.8944 56.8165L54.8279 58.9795C53.9252 58.9795 53.0872 58.7035 52.3942 58.2302C50.3377 56.8277 47.9347 56.0212 45.4457 56.0212H39.5654V54.6535L48.4284 53.8782L54.8279 54.6535Z"
          fill="#FCA50B"
        />
        <path
          d="M54.8279 50.3267L56.7204 52.654L54.8279 54.6537H39.5654V53.286H45.4457C47.9349 53.286 50.3377 52.4787 52.3942 51.0762C53.0872 50.6035 53.9252 50.3267 54.8279 50.3267Z"
          fill="#FEC609"
        />
        <path
          d="M70.0904 53.286V54.6537H54.8279V50.327C55.7306 50.327 56.5676 50.6037 57.2614 51.0762C59.3171 52.4787 61.7209 53.286 64.2099 53.286H70.0904Z"
          fill="#FCA50B"
        />
        <path
          d="M70.0904 54.6535V56.0212H64.2101C61.7209 56.0212 59.3171 56.8277 57.2616 58.2302C56.5679 58.7035 55.7306 58.9795 54.8281 58.9795V54.6535L61.4454 53.5742L70.0904 54.6535Z"
          fill="#FF8B00"
        />
        <path
          d="M122.995 39.84H122.12C119.63 39.84 117.228 40.6475 115.17 42.05C114.478 42.5225 113.64 42.7975 112.738 42.7975V38.4725H122.4C122.605 38.925 122.803 39.38 122.995 39.84Z"
          fill="#FF8B00"
        />
        <path
          d="M79.3726 116.157L64.0001 128.687C43.7651 128.687 25.7226 119.295 13.9951 104.632C13.9176 104.537 13.8426 104.442 13.7676 104.345H64.0001L79.3726 116.157Z"
          fill="#602558"
        />
        <path
          d="M114.232 104.345C114.157 104.442 114.082 104.537 114.005 104.632C102.77 118.677 85.7425 127.887 66.54 128.635C65.6975 128.67 64.85 128.687 64 128.687V104.345H114.232Z"
          fill="#501845"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4_461">
        <rect width="128" height="128" fill="white" transform="translate(0 0.6875)" />
      </clipPath>
      <clipPath id="clip1_4_461">
        <rect width="128" height="128" fill="white" transform="translate(0 0.6875)" />
      </clipPath>
    </defs>
  </svg>
);

export const DrumsIcon = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 120 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M112.106 29.8134C112.106 46.9865 88.4601 64.2091 67.5327 67.7695C66.9726 67.8637 66.4148 67.9508 65.8593 68.0238C65.2992 68.1015 64.7413 68.1674 64.1882 68.2216C63.6257 68.2781 63.0679 68.3228 62.5124 68.3582C62.2734 68.3723 62.0343 68.3841 61.7976 68.3958C61.4765 68.41 61.1577 68.4217 60.839 68.4288C60.5601 68.4359 60.2835 68.4382 60.007 68.4382H59.9999C59.7234 68.4382 59.4445 68.4359 59.1656 68.4288C58.6124 68.417 58.0546 68.3911 57.4945 68.3535C56.939 68.3181 56.3812 68.271 55.821 68.2098C55.2656 68.1533 54.7077 68.0827 54.1476 68.0002C53.5921 67.9225 53.0343 67.833 52.4765 67.7318C31.5445 63.9736 7.89368 45.8869 7.89368 29.8134C16.9452 13.9283 32.9812 2.57844 51.7991 0H59.1656H68.2007C87.0163 2.5808 103.057 13.9307 112.106 29.8134Z"
      fill="#8B2D2D"
    />
    <path
      d="M120 59.7187C120 93.01 93.1359 120 60 120C26.8641 120 0 93.01 0 59.7187C0 48.8351 2.87109 38.6273 7.89375 29.8135C18.2344 47.9615 37.6969 60.1896 60 60.1896C82.3031 60.1896 101.768 47.9615 112.106 29.8135C117.129 38.6273 120 48.8351 120 59.7187Z"
      fill="#5E2121"
    />
    <g clipPath="url(#clip0_6_613)">
      <path
        d="M33.18 34.454V113.016C31.9999 112.242 30.8559 111.418 29.748 110.55V34.454C29.748 33.506 30.516 32.738 31.464 32.738C32.412 32.738 33.18 33.506 33.18 34.454Z"
        fill="#FFC83F"
      />
      <path
        d="M91.962 30.898V109.142C90.86 110.09 89.7139 110.992 88.5301 111.842V30.898C88.5301 29.9521 89.298 29.1821 90.246 29.1821C91.194 29.1821 91.962 29.9521 91.962 30.898Z"
        fill="#FFC83F"
      />
      <path
        d="M45.184 113.532L43.6461 118.204C42.5621 117.822 41.496 117.4 40.448 116.944L41.9261 112.458C42.222 111.558 43.192 111.068 44.092 111.364C44.992 111.662 45.482 112.632 45.184 113.532Z"
        fill="#F8F8F8"
      />
      <path
        d="M80.5 116.518C79.4601 116.998 78.402 117.442 77.324 117.85L75.902 113.532C75.6061 112.632 76.0961 111.662 76.9961 111.364C77.8961 111.068 78.8662 111.558 79.1621 112.458L80.5 116.518Z"
        fill="#F8F8F8"
      />
      <path
        d="M100.431 72.8194L87.0748 77.2621L74.65 81.3961L76.1143 64.7802C77.7981 63.2338 80.4885 61.6712 83.6913 60.5066C89.6762 58.3332 95.1874 58.3836 95.9995 60.6211L100.431 72.8194Z"
        fill="#8A6D5B"
      />
      <path
        d="M87.075 77.2621L74.6502 81.3961L76.1145 64.7801C77.7983 63.2337 80.4887 61.6711 83.6915 60.5066C83.6915 60.5066 80.9255 67.6466 86.5877 73.3088C88.0244 74.7455 87.9648 76.0748 87.075 77.2621Z"
        fill="#D3A178"
      />
      <path
        d="M46.3964 81.3962L26.287 74.7069L20.6157 72.8194L25.0471 60.6211C25.6121 59.0656 28.449 58.5668 32.1391 59.1387C33.7544 59.3902 35.532 59.8457 37.3551 60.5067C40.5579 61.671 43.246 63.2336 44.9298 64.7802L46.3964 81.3962Z"
        fill="#8A6D5B"
      />
      <path
        d="M32.1389 59.1387C29.8855 62.369 26.3096 68.402 26.3096 74.1442C26.3096 74.3409 26.3027 74.5285 26.2869 74.7069L20.6155 72.8194L25.0469 60.6211C25.612 59.0654 28.4488 58.5666 32.1389 59.1387Z"
        fill="#D3A178"
      />
      <path
        d="M33.18 75.954V84.93C32.1479 84.682 31.072 84.3581 29.982 83.9621C29.9039 83.9341 29.826 83.9041 29.7479 83.8761V74.9001C30.7738 75.1461 31.8418 75.4661 32.9239 75.8602C33.01 75.892 33.0959 75.9219 33.18 75.954Z"
        fill="#FFA340"
      />
      <path
        d="M34.1688 81.9933C32.841 81.7276 31.4246 81.3316 29.9827 80.8076C23.9959 78.6318 19.803 75.0562 20.6159 72.8198C21.4288 70.5834 26.938 70.5321 32.9248 72.7055C34.7558 73.3695 36.4166 74.1637 37.8191 75.0118L41.522 78.7147L34.1688 81.9933Z"
        fill="#F8F8F8"
      />
      <path
        d="M91.962 74.1941V83.0662C91.668 83.1841 91.368 83.2981 91.0639 83.4082C90.2058 83.7202 89.356 83.9862 88.5299 84.2062V75.1622C89.708 74.752 90.862 74.4299 91.962 74.1941Z"
        fill="#FFA340"
      />
      <path
        d="M86.8773 81.9933C88.2051 81.7276 89.6215 81.3316 91.0633 80.8076C97.0501 78.6318 101.243 75.0562 100.43 72.8198C99.6171 70.5834 94.108 70.5321 88.1212 72.7055C86.2902 73.3695 84.6294 74.1637 83.227 75.0118L82.9312 78.6408V82.5852L86.8773 81.9933Z"
        fill="#F8F8F8"
      />
      <path
        d="M76.1577 57.5461V68.1064H44.9298V57.5461C44.9298 55.6382 49.2056 54.0116 55.1949 53.3915C56.8627 53.2198 58.6655 53.126 60.5438 53.126C69.1664 53.1262 76.1577 55.1076 76.1577 57.5461Z"
        fill="#8A6D5B"
      />
      <path
        d="M55.1949 53.3917C54.5817 56.1187 53.9161 60.4449 53.9161 66.3654C53.9161 67.0174 53.8681 67.5962 53.7766 68.1065H44.9298V57.5462C44.9298 55.6383 49.2056 54.0117 55.1949 53.3917Z"
        fill="#D3A178"
      />
      <path
        d="M60.9681 118.936C76.4144 118.936 88.9362 106.414 88.9362 90.9681C88.9362 75.5217 76.4144 63 60.9681 63C45.5217 63 33 75.5217 33 90.9681C33 106.414 45.5217 118.936 60.9681 118.936Z"
        fill="white"
      />
      <circle cx="60.5" cy="90.5" r="22.5" fill="#D3A178" />
      <path
        d="M60.5436 120.084C44.6806 120.084 31.7749 107.178 31.7749 91.3152C31.7749 75.4522 44.6804 62.5466 60.5436 62.5466C76.4068 62.5466 89.3121 75.4522 89.3121 91.3152C89.3121 107.178 76.4066 120.084 60.5436 120.084ZM60.5436 64.1466C45.5628 64.1466 33.3748 76.3344 33.3748 91.3152C33.3748 106.296 45.5626 118.484 60.5436 118.484C75.5246 118.484 87.7122 106.296 87.7122 91.3152C87.7122 76.3344 75.5244 64.1466 60.5436 64.1466Z"
        fill="#E2E2E2"
      />
      <path
        d="M91.962 34.52V45.3599C91.3979 45.3739 90.8241 45.3819 90.246 45.3819C89.668 45.3819 89.0939 45.3739 88.5301 45.3599V34.52C89.0941 34.506 89.668 34.498 90.246 34.498C90.8241 34.498 91.3981 34.506 91.962 34.52Z"
        fill="#FFA340"
      />
      <path
        d="M109 36.3401C109 37.522 107.698 38.6201 105.486 39.5121C102.082 40.886 96.5239 41.7821 90.246 41.7821C79.8881 41.7821 71.492 39.3461 71.492 36.3401C71.492 34.1261 76.054 32.2201 82.6001 31.37C84.936 31.0661 87.524 30.898 90.246 30.898C100.602 30.898 109 33.336 109 36.3401Z"
        fill="#FFC83F"
      />
      <path
        d="M33.18 44.2641V52.418C32.618 52.4379 32.0459 52.448 31.464 52.448C30.884 52.448 30.31 52.4381 29.748 52.4161V44.2641C30.31 44.2421 30.8821 44.2321 31.464 44.2321C32.0461 44.2319 32.618 44.2421 33.18 44.2641Z"
        fill="#FFA340"
      />
      <path
        d="M45.6177 45.34C45.6177 46.2319 44.6351 47.0607 42.9658 47.7339C40.3967 48.7709 36.2021 49.4472 31.4638 49.4472C23.6464 49.4472 17.3099 47.6085 17.3099 45.34C17.3099 43.669 20.7529 42.2306 25.6933 41.589C27.4563 41.3595 29.4095 41.2328 31.4638 41.2328C39.2795 41.2328 45.6177 43.0728 45.6177 45.34Z"
        fill="#FFA340"
      />
      <path
        d="M45.6177 42.14C45.6177 43.032 44.6351 43.8608 42.9658 44.5339C40.3967 45.571 36.2021 46.2472 31.4638 46.2472C23.6464 46.2472 17.3099 44.4086 17.3099 42.14C17.3099 40.4691 20.7529 39.0306 25.6933 38.389C27.4563 38.1595 29.4095 38.0328 31.4638 38.0328C39.2795 38.0328 45.6177 39.8728 45.6177 42.14Z"
        fill="#FFC83F"
      />
      <path
        d="M109 36.3401C109 37.522 107.698 38.6201 105.486 39.5121C103.152 39.8141 100.566 39.9822 97.846 39.9822C87.488 39.9822 79.092 37.5461 79.092 34.5401C79.092 33.3582 80.392 32.2641 82.6001 31.37C84.936 31.0661 87.524 30.898 90.246 30.898C100.602 30.898 109 33.336 109 36.3401Z"
        fill="#FFDD7D"
      />
      <path
        d="M90.2454 37.1995C89.2978 37.1995 88.5297 36.4314 88.5297 35.4837V28.4539C88.5297 27.5063 89.2978 26.7382 90.2454 26.7382C91.1931 26.7382 91.9612 27.5063 91.9612 28.4539V35.4835C91.9612 36.4312 91.1929 37.1995 90.2454 37.1995Z"
        fill="#FFC83F"
      />
      <path
        d="M31.4638 42.1994C30.5162 42.1994 29.748 41.4313 29.748 40.4836V33.454C29.748 32.5064 30.5162 31.7383 31.4638 31.7383C32.4115 31.7383 33.1796 32.5064 33.1796 33.454V40.4836C33.1796 41.4313 32.4115 42.1994 31.4638 42.1994Z"
        fill="#FFDD7D"
      />
      <path
        d="M84.9041 114.206C84.4361 114.484 83.96 114.754 83.4821 115.018C82.9961 115.284 82.5061 115.54 82.0102 115.79L69.7441 106.144L70.6822 104.95L71.6203 103.758L84.9041 114.206Z"
        fill="#6C4E94"
      />
      <path
        d="M83.4819 115.018C82.9959 115.284 82.5059 115.54 82.01 115.79L69.7439 106.144L70.682 104.95L83.4819 115.018Z"
        fill="#4E3570"
      />
      <path
        d="M70.8099 100.134L73.4884 102.24C74.4265 102.978 74.5886 104.337 73.8509 105.275L71.7441 107.953C71.0064 108.891 69.6476 109.053 68.7097 108.316L66.0312 106.209C65.0931 105.471 64.931 104.112 65.6687 103.175L67.7755 100.496C68.5132 99.558 69.872 99.3958 70.8099 100.134Z"
        fill="#E2E2E2"
      />
      <path
        d="M70.8099 100.134L73.4884 102.24C74.4265 102.978 74.5886 104.337 73.8509 105.275L73.3902 105.861C72.6525 106.799 71.2937 106.961 70.3558 106.223L67.6773 104.116C66.7392 103.379 66.5771 102.02 67.3148 101.082L67.7755 100.496C68.5132 99.558 69.872 99.3958 70.8099 100.134Z"
        fill="#F8F8F8"
      />
    </g>
    <defs>
      <clipPath id="clip0_6_613">
        <rect width="98" height="98" fill="white" transform="translate(11 23)" />
      </clipPath>
    </defs>
  </svg>
);

export const StringsIcon = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M107.013 53.5065C107.013 81.9853 84.7655 105.266 56.7018 106.917C55.6448 106.982 54.579 107.013 53.5068 107.013C52.4345 107.013 51.3687 106.983 50.3092 106.917C22.2477 105.266 0 81.9853 0 53.5065C0.00025 23.9555 23.9558 0 53.5068 0C54.5923 0 55.671 0.0327502 56.7412 0.0982502C58.0255 0.1725 59.2965 0.29475 60.5568 0.46075C60.5588 0.46275 60.5587 0.46275 60.5612 0.46275C86.7767 3.9135 107.013 26.347 107.013 53.5065Z"
      fill="#D6BE9A"
    />
    <circle cx="54" cy="54" r="35" fill="#F3C69D" />
    <path
      d="M40.6871 45.8399C36.8383 51.2333 36.178 58.7923 42.071 65.3324C46.0517 63.8876 49.4898 65.941 52.6839 69.1147C56.1934 72.6018 56.8941 77.8201 54.7921 82.0019L56.2242 83.5944C62.3913 90.4516 73.0909 90.75 79.6352 84.2473L83.665 80.2433C90.2095 73.7405 89.9091 63.1092 83.0078 56.9814L81.4052 55.5583C77.1965 57.6469 71.9448 56.9507 68.4353 53.4636C65.2413 50.2899 63.1747 46.8736 64.6287 42.9183C58.1907 37.1922 50.537 37.8079 45.0413 41.573L40.6871 45.8399Z"
      fill="#D68458"
    />
    <path
      d="M58.9686 42.9182C57.5146 46.8735 59.5812 50.2898 62.7752 53.4635C65.6955 56.3652 69.8217 57.3325 73.5498 56.3728C71.6762 55.8903 69.9033 54.9219 68.4355 53.4635C65.2414 50.2898 63.1749 46.8734 64.6288 42.9182C60.3733 39.133 55.5868 38.1197 51.2431 38.9546C53.8704 39.4686 56.5082 40.7298 58.9686 42.9182Z"
      fill="#C77B52"
    />
    <path
      d="M83.008 56.9813L81.4053 55.5582C80.0304 56.2405 78.5442 56.6236 77.0438 56.7113L77.3479 56.9813C84.2491 63.109 84.5494 73.7404 78.0051 80.2431L73.9753 84.2471C71.5452 86.6618 68.542 88.1378 65.4108 88.6893C70.4052 89.5697 75.7519 88.1059 79.6355 84.2471L83.6653 80.2431C90.2095 73.7404 89.9092 63.109 83.008 56.9813Z"
      fill="#C77B52"
    />
    <path
      d="M82.9465 80.9572L80.3541 83.5331L76.9768 80.1773C74.3408 77.5581 71.4225 75.2355 68.2746 73.2514L72.5989 68.9546C74.5957 72.0824 76.9332 74.9822 79.5691 77.6013L82.9465 80.9572Z"
      fill="#AA6946"
    />
    <path
      d="M60.1898 86.801C65.3763 89.774 71.908 89.6558 77.0034 86.3674C68.4791 76.2437 61.2753 85.3052 60.1898 86.801Z"
      fill="black"
    />
    <path
      d="M53.6663 50.1427L32.7815 30.7672L30.1567 31.0613L29.8476 33.6933L49.342 54.4394L53.6663 50.1427Z"
      fill="#FFF2E8"
    />
    <path
      d="M30.4858 28.6376C28.5751 26.865 27.2458 24.5617 26.671 22.0278L24.8458 20.2144C23.9717 19.3458 22.7408 18.9305 21.5152 19.0907C19.7301 19.324 18.3255 20.7197 18.0908 22.4932C17.9296 23.711 18.3475 24.9341 19.2217 25.8026L21.0468 27.6161C23.597 28.1872 25.915 29.5082 27.699 31.4067L29.8476 33.6933L32.7815 30.7673L30.4858 28.6376Z"
      fill="#AA6946"
    />
    <path
      d="M89.4396 68.4448C89.3065 63.7017 87.2727 59.3487 83.7125 56.1876C83.0756 55.6221 81.9185 54.1189 80.9334 54.6074C77.6011 56.2612 73.6954 55.9608 70.6932 53.9468L87.5002 36.6247C89.1012 34.9511 89.7725 32.6034 89.2959 30.3443L88.6248 27.1631C88.342 25.8235 86.2655 26.2618 86.5479 27.6013L86.6552 28.1101L66.3052 49.1362C65.1235 47.0923 64.9192 45.2041 65.625 43.2843C65.7754 42.8747 65.6603 42.415 65.3342 42.125C62.1416 39.2855 58.3988 37.7295 54.5103 37.6253C51.1275 37.534 47.7785 38.5171 44.7948 40.4648L31.3445 27.9865L32.8965 26.4444C33.8676 25.4795 32.3715 23.9737 31.4005 24.9386L29.8994 26.4301C29.5238 25.947 29.1876 25.4369 28.8926 24.904L30.835 22.9738C31.8062 22.0089 30.31 20.5031 29.339 21.4681L27.9868 22.8117C27.1307 20.1552 24.2784 17.6594 21.3777 18.0383C19.1202 18.3333 17.336 20.1079 17.0387 22.3539C16.6555 25.2488 19.1833 28.0881 21.8313 28.9281L20.4932 30.2577C19.5219 31.2228 21.0185 32.7281 21.9892 31.7634L23.9388 29.8265C24.4756 30.1191 24.9894 30.4528 25.4761 30.8254L23.9859 32.306C23.0146 33.271 24.5112 34.7764 25.482 33.8117L27.0441 32.2596L39.5712 45.5909C37.5809 48.5273 36.5755 51.8342 36.6651 55.1845C36.7684 59.0501 38.3653 62.8049 41.2827 66.0427C41.5719 66.3638 42.027 66.4774 42.4331 66.33C44.5411 65.5649 46.6101 65.8722 48.8836 67.3389L42.2337 74.2901C40.6327 75.9637 39.9614 78.3114 40.4382 80.5705L40.7704 82.1458L34.9753 88.2035C34.0299 89.1918 35.5609 90.662 36.5091 89.6708L42.686 83.2139C42.6864 83.2133 42.687 83.2129 42.6874 83.2123L53.514 71.895C55.2307 74.7943 55.4086 78.412 53.8438 81.5251C53.343 82.5213 54.8562 83.66 55.4352 84.3039C58.6133 87.8377 62.9888 89.8577 67.7554 89.9914C73.8573 90.1618 78.2801 87.09 82.3982 82.9979C86.5018 78.9206 89.6105 74.5334 89.4396 68.4448ZM87.184 30.6158L87.2192 30.7825C87.551 32.3554 87.0828 33.9907 85.9718 35.1521L69.0581 52.584C68.4881 52.0105 67.9834 51.4534 67.5426 50.9097L87.184 30.6158ZM31.3244 33.7151L32.8088 32.2403L52.1342 50.1691L49.3682 52.9175L31.3244 33.7151ZM24.3575 27.6543C23.4504 27.0135 22.2069 27.0118 21.324 26.3954C20.1566 25.5804 18.9436 24.138 19.1429 22.6324C19.3142 21.3373 20.3464 20.3137 21.6526 20.143C22.9426 19.9741 24.1696 20.813 24.9824 21.7344C25.9273 22.8056 25.9187 24.2027 26.7175 25.3244C27.8021 27.5357 29.4788 29.151 31.2515 30.7954L29.8704 32.1676C28.2101 30.4009 26.5804 28.731 24.3575 27.6543ZM42.5477 80.2878L42.5149 80.1324C42.1831 78.5598 42.6513 76.9242 43.7675 75.7575L50.5919 68.6238C51.0306 68.9985 51.478 69.4124 51.9361 69.8675C52.0357 69.9664 52.1328 70.0673 52.2274 70.1695L42.5477 80.2878ZM57.0134 82.8846L56.0501 81.8135C58.0184 77.2381 57.0085 71.9156 53.4319 68.3617C50.9346 65.8803 47.1246 62.8116 42.414 64.1096C40.1226 61.3753 38.871 58.2827 38.7867 55.1277C38.7131 52.375 39.5004 49.6455 41.0655 47.1815L48.5684 55.1662C48.9694 55.5928 49.6748 55.6047 50.0898 55.1924L54.4141 50.8956C54.8362 50.4761 54.8242 49.7695 54.3879 49.3648L46.4042 41.9579C50.8878 39.2509 57.4299 38.3285 63.4028 43.2645C62.1018 47.9484 65.1896 51.7345 67.6873 54.2163C71.2626 57.7688 76.6179 58.7703 81.2188 56.8119L82.3033 57.7749C85.4205 60.5427 87.2014 64.3532 87.3178 68.5044C87.4339 72.6396 85.8813 76.5287 82.946 79.4609L80.317 76.8487C77.7406 74.2887 75.4448 71.4407 73.4933 68.3837C73.1344 67.8216 72.3238 67.7315 71.8507 68.2018L67.5263 72.4986C67.0494 72.9724 67.1397 73.7909 67.7084 74.1493C70.7855 76.0886 73.6519 78.3701 76.2285 80.9301L78.8476 83.5325C78.2698 84.1027 77.6548 84.6196 77.0086 85.0823C74.1216 81.8776 71.0808 80.3456 67.9589 80.522C63.9291 80.7527 60.9996 83.7899 59.7816 85.3015C58.7776 84.6206 57.848 83.8127 57.0134 82.8846ZM80.3541 82.037L77.7247 79.4244C75.3518 77.0666 72.7433 74.9357 69.9558 73.0768L72.4251 70.6234C74.2976 73.3972 76.4451 75.9934 78.821 78.3541L81.4407 80.9571C81.0784 81.3171 80.7163 81.6771 80.3541 82.037ZM67.815 87.8698C65.6315 87.8086 63.5423 87.2953 61.6473 86.3784C62.7571 85.07 65.089 82.8124 68.0803 82.6412C70.4373 82.5065 72.8168 83.7074 75.1643 86.2121C72.9276 87.3672 70.4188 87.9429 67.815 87.8698Z"
      fill="#060606"
    />
    <path
      d="M60.0701 71.7884C61.7822 70.719 62.0452 68.2489 60.59 66.8466L56.323 62.7353C55.8453 62.2751 55.9332 61.4731 56.4944 61.1224C57.6556 60.3973 56.5312 58.5968 55.3701 59.322C53.6579 60.3914 53.395 62.8615 54.8503 64.2638L59.1172 68.3751C59.5949 68.8355 59.5071 69.6375 58.9457 69.988C57.7933 70.7079 58.8948 72.5223 60.0701 71.7884Z"
      fill="#060606"
    />
    <path
      d="M59.073 57.4347C59.5684 57.7483 60.224 57.6005 60.5373 57.1051C60.8945 56.5405 61.7137 56.4582 62.1792 56.9355L66.317 61.1752C67.7244 62.6175 70.1944 62.3611 71.2718 60.6578C72.0037 59.5008 70.2099 58.3662 69.4779 59.523C69.1206 60.0876 68.3017 60.1697 67.836 59.6927L63.6983 55.4529C62.2923 54.0122 59.8207 54.2674 58.7435 55.9704C58.4302 56.4658 58.5776 57.1214 59.073 57.4347Z"
      fill="#060606"
    />
  </svg>
);

export const BrassIcon = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M107.013 53.5065C107.013 81.9853 84.7655 105.266 56.7018 106.917C55.6448 106.982 54.579 107.013 53.5068 107.013C52.4345 107.013 51.3687 106.983 50.3092 106.917C22.2477 105.266 0 81.9853 0 53.5065C0.00025 23.9555 23.9558 0 53.5068 0C54.5923 0 55.671 0.0327502 56.7412 0.0982502C58.0255 0.1725 59.2965 0.29475 60.5568 0.46075C60.5588 0.46275 60.5587 0.46275 60.5612 0.46275C86.7767 3.9135 107.013 26.347 107.013 53.5065Z"
      fill="#526D4D"
    />
    <g clipPath="url(#clip0_15_676)">
      <circle cx="54" cy="54" r="35" fill="#6A9164" />
      <path
        d="M87.8019 41.5485C86.7188 42.6622 84.9626 42.6622 83.8795 41.5485L65.1503 22.2918C64.0672 21.1783 64.0672 19.3726 65.1503 18.259C66.2333 17.1453 67.9895 17.1453 69.0726 18.259L87.8017 37.5157C88.8849 38.6293 88.8849 40.435 87.8019 41.5485Z"
        fill="#F7E4B4"
      />
      <path
        d="M29.0428 86.7389C27.9596 87.8526 26.2035 87.8526 25.1205 86.7389L21.1981 82.7061C20.1151 81.5925 20.1151 79.7869 21.1981 78.6733C22.2813 77.5597 24.0374 77.5597 25.1205 78.6733L29.0428 82.7061C30.1259 83.8197 30.1259 85.6252 29.0428 86.7389Z"
        fill="#F7E4B4"
      />
      <path
        d="M69.3161 62.5111C69.3161 65.6151 68.1637 68.7191 65.8603 71.0874L53.3018 83.9996C48.695 88.7362 41.2274 88.7362 36.6205 83.9996C34.998 82.3314 33.9469 80.2982 33.4684 78.1566L40.1069 71.3811C39.1777 72.556 38.7132 73.9904 38.7132 75.4247C38.7132 77.0687 39.3233 78.7127 40.5437 79.9674C42.983 82.4754 46.9394 82.4754 49.3787 79.9674L61.9386 67.0537C63.1589 65.799 63.7677 64.1565 63.7677 62.5111C63.7677 60.8671 63.1589 59.2231 61.9386 57.9684C59.7752 55.7456 56.4207 55.4932 53.9883 57.2113L60.3369 50.731C62.3615 51.2414 64.2794 52.3108 65.8603 53.9362C68.1637 56.3043 69.3161 59.4085 69.3161 62.5111Z"
        fill="#F1CB6F"
      />
      <path
        d="M53.9883 57.2113L40.1069 71.3811C40.2414 71.2086 40.3884 71.0418 40.5437 70.8821L53.1022 57.9684C53.3795 57.6832 53.6763 57.4309 53.9883 57.2113Z"
        fill="#F1CB6F"
      />
      <path
        d="M40.9403 70.4757L29.0433 82.7064L25.1202 78.6728L37.0172 66.4421L48.7838 54.3426L54.2337 48.7391C58.4301 44.426 61.3742 38.995 62.7346 33.0565L65.1919 22.3358L83.8368 41.5059L73.4098 44.0325C67.634 45.4312 62.3518 48.4582 58.1569 52.7727L52.7069 58.3762L40.9403 70.4757Z"
        fill="#F1CB6F"
      />
      <path
        d="M35.0483 64.4229L38.97 60.3906L53.6879 75.523L49.7661 79.5553L35.0483 64.4229Z"
        fill="#F7E4B4"
      />
      <path
        d="M42.8929 56.3589L46.8146 52.3267L61.5325 67.4591L57.6107 71.4914L42.8929 56.3589Z"
        fill="#F7E4B4"
      />
      <path
        d="M88.7827 36.5076L70.0534 17.2507C68.4312 15.5829 65.7919 15.5832 64.1698 17.2507C62.7308 18.7304 62.5697 21.0329 63.6841 22.6982L61.3848 32.7296C60.0825 38.414 57.2709 43.6015 53.2531 47.7308L48.7835 52.3265L47.8029 51.3183C47.2613 50.7616 46.3834 50.7616 45.8416 51.3183L44.8612 52.3263L42.9 50.3099L43.8806 49.3017C44.4221 48.745 44.4221 47.8421 43.8806 47.2853C43.3389 46.7286 42.4611 46.7286 41.9193 47.2853L37.997 51.3183C37.4555 51.8751 37.4555 52.7779 37.997 53.3347C38.2679 53.6131 38.6227 53.7523 38.9776 53.7523C39.3325 53.7523 39.6873 53.613 39.9582 53.3347L40.9388 52.3265L42.8999 54.3429L41.9193 55.3511C41.3778 55.9079 41.3778 56.8107 41.9193 57.3676L42.8999 58.3758L40.9388 60.3922L39.9582 59.384C39.4165 58.8274 38.5387 58.8274 37.9969 59.384L37.0163 60.3922L35.0552 58.376L36.0357 57.3678C36.5773 56.811 36.5773 55.9081 36.0357 55.3512C35.4941 54.7944 34.6162 54.7944 34.0744 55.3512L30.1521 59.384C29.6106 59.9408 29.6106 60.8436 30.1521 61.4005C30.423 61.679 30.7778 61.8182 31.1327 61.8182C31.4877 61.8182 31.8425 61.679 32.1133 61.4005L33.0939 60.3923L35.055 62.4086L34.0744 63.4168C33.5329 63.9736 33.5329 64.8764 34.0744 65.4332L35.0557 66.4421L24.9512 76.8299C23.4052 76.0729 21.4956 76.3508 20.2173 77.665C18.5955 79.3328 18.5955 82.0464 20.2173 83.7142L24.1397 87.747C24.9255 88.555 25.9701 88.9999 27.0814 88.9999C28.1928 88.9999 29.2376 88.5549 30.0233 87.747C31.3015 86.4328 31.5716 84.4695 30.8354 82.8798L32.8592 80.7993C33.5146 82.3605 34.4544 83.7888 35.6398 85.0077C38.2096 87.6499 41.5854 88.9711 44.961 88.9711C48.3368 88.9711 51.7125 87.6499 54.2824 85.0077L56.1483 83.0891C56.6898 82.5323 56.6898 81.6295 56.1483 81.0727C55.6066 80.5159 54.7288 80.5159 54.187 81.0727L52.3211 82.9912C48.263 87.164 41.6593 87.164 37.601 82.9912C36.3955 81.7518 35.5108 80.2399 35.0148 78.5831L37.3608 76.1713C37.5264 77.986 38.293 79.6697 39.5623 80.9749C41.0042 82.4576 42.9215 83.2742 44.9609 83.2742C47.0003 83.2742 48.9175 82.4576 50.3597 80.9751L62.9186 68.0623C64.3605 66.5796 65.1547 64.6082 65.1547 62.5114C65.1547 60.4146 64.3605 58.4434 62.9186 56.9607C61.6491 55.6553 60.0111 54.8671 58.2459 54.697L59.1373 53.7805C59.6332 53.2705 60.1448 52.7796 60.6711 52.3081C62.2508 52.8239 63.6949 53.7263 64.8793 54.9443C66.846 56.9662 67.9289 59.6533 67.9289 62.511C67.9289 65.3693 66.846 68.0571 64.8793 70.0791L63.012 71.9989C62.4705 72.5557 62.4705 73.4586 63.012 74.0155C63.2829 74.2939 63.6377 74.4331 63.9926 74.4331C64.3476 74.4331 64.7024 74.2939 64.9732 74.0155L66.8405 72.0956C69.3308 69.535 70.7024 66.1311 70.7024 62.5111C70.7024 58.8918 69.3308 55.4885 66.8405 52.928C65.7733 51.8309 64.5387 50.9366 63.1938 50.2764C66.3588 47.9927 69.929 46.3402 73.7276 45.4204L83.4838 43.0564C84.1907 43.5565 85.0153 43.8078 85.8404 43.8078C86.9058 43.8078 87.9712 43.3909 88.7823 42.557C90.4046 40.8891 90.4045 38.1754 88.7827 36.5076ZM46.8222 54.343L59.5811 67.4613L57.6199 69.4777L44.8611 56.3594L46.8222 54.343ZM55.6588 71.4941L53.6976 73.5105L46.823 66.4422L48.7842 64.4258L55.6588 71.4941ZM44.8612 60.3923L46.823 62.4095L44.8619 64.4258L42.9 62.4087L44.8612 60.3923ZM51.7365 75.5269L49.7753 77.5433L37.0164 64.425L38.9776 62.4086L51.7365 75.5269ZM38.979 70.4757L29.0434 80.69L27.0814 78.6728L37.017 68.4585L38.979 70.4757ZM28.0623 85.7306C27.8003 85.9999 27.4523 86.1482 27.0817 86.1482C26.7113 86.1482 26.3631 85.9999 26.1013 85.7306L22.1788 81.6978C21.6383 81.1419 21.6383 80.2372 22.1788 79.6814C22.4491 79.4034 22.8044 79.2644 23.1594 79.2644C23.5144 79.2644 23.8697 79.4034 24.14 79.6814L28.0623 83.7142C28.6031 84.2703 28.6031 85.1748 28.0623 85.7306ZM41.5238 78.9587C40.6057 78.0146 40.0999 76.7595 40.0999 75.4243C40.0999 74.3772 40.4122 73.38 40.9894 72.5428L47.7638 79.508C46.9495 80.1015 45.9796 80.4226 44.9612 80.4226C43.6628 80.4226 42.442 79.9027 41.5238 78.9587ZM62.3816 62.5115C62.3816 63.5587 62.0693 64.5559 61.4921 65.3931L54.7177 58.4278C55.532 57.8344 56.5019 57.5133 57.5205 57.5133C58.8189 57.5133 60.0397 58.0332 60.9578 58.9774C61.8759 59.9214 62.3816 61.1765 62.3816 62.5115ZM73.092 42.6446C67.0608 44.1052 61.5572 47.2588 57.1763 51.7644L52.7066 56.3601L50.7446 54.3429L55.2143 49.7473C59.5967 45.2429 62.664 39.5842 64.0844 33.3835L65.9711 25.1519L81.0976 40.7046L73.092 42.6446ZM86.8214 40.5404C86.2806 41.0963 85.4008 41.0961 84.8601 40.5404L66.1311 21.2835C65.5904 20.7276 65.5904 19.8231 66.1311 19.2671C66.4014 18.9891 66.7566 18.8502 67.1116 18.8502C67.4669 18.8502 67.8219 18.9892 68.0921 19.2671L86.8214 38.5238C87.362 39.0799 87.362 39.9844 86.8214 40.5404Z"
        fill="black"
      />
      <path
        d="M59.5803 78.97C60.3462 78.97 60.9671 78.3316 60.9671 77.5442C60.9671 76.7568 60.3462 76.1184 59.5803 76.1184C58.8145 76.1184 58.1936 76.7568 58.1936 77.5442C58.1936 78.3316 58.8145 78.97 59.5803 78.97Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_676">
        <rect width="71" height="73" fill="white" transform="translate(19 16)" />
      </clipPath>
    </defs>
  </svg>
);

export const ReedIcon = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="50" cy="50" r="50" fill="#976dff" />
    <circle cx="40.5" cy="63.5" r="26.5" fill="#8555fa" />
    <g clipPath="url(#clip0_24_922)">
      <path
        d="M45.1405 47.6119L23.7171 54.1671C22.608 54.5064 21.4328 53.8828 21.092 52.7741L21.0766 52.7238C20.7359 51.6152 21.3588 50.4414 22.4679 50.1019L43.8918 43.5466C45.0008 43.2073 46.176 43.8309 46.5168 44.9397L46.5322 44.9899C46.8726 46.0988 46.2497 47.2726 45.1405 47.6119Z"
        fill="#FFE682"
      />
      <path
        d="M24.8524 53.8197C24.8524 53.8197 27.8147 58.5186 25.5567 62.7738C23.2987 67.029 17.5925 76.8291 29.1899 82.9834C40.7872 89.1376 47.5789 82.626 53.1768 69.0622C58.7746 55.4982 68.4664 27.151 71.7167 28.1204C74.7165 29.0153 74.1759 33.5186 73.837 35.9677L79.1413 38.7825L84.4384 35.9369L78.6959 32.8896C78.6959 32.8896 77.9396 24.2383 74.1847 22.2457C68.1301 19.0327 63.797 26.1472 59.2845 34.7972C53.7336 45.4377 41.0121 75.1471 36.6442 72.8292C30.9677 69.8169 47.3837 59.2177 44.1874 47.9037L24.8524 53.8197Z"
        fill="#FFD039"
      />
      <path
        d="M31.6399 71.2383C31.6888 72.4884 34.358 74.8896 36.3704 72.6658C31.6103 69.5024 46.8152 59.3622 44.326 48.45C44.3239 48.4405 44.3219 48.4311 44.3196 48.4217C44.2797 48.2492 44.2359 48.0768 44.187 47.9037L41.0064 48.877C41.1427 59.0665 31.4109 65.3709 31.6399 71.2383Z"
        fill="#FFAE47"
      />
      <path
        d="M84.4381 35.9368L78.6957 32.8895L73.8369 35.9679L79.1412 38.7826L84.4381 35.9368Z"
        fill="#494949"
      />
      <path
        d="M69.6934 29.7438C69.7158 29.7114 69.7381 29.6796 69.7603 29.648C69.8041 29.5858 69.8475 29.5254 69.8905 29.4666C69.9086 29.4417 69.927 29.4161 69.9452 29.3918C70.0033 29.3137 70.0609 29.2389 70.1176 29.1673C70.1345 29.1462 70.1509 29.1266 70.1676 29.106C70.2099 29.0539 70.252 29.0032 70.2935 28.9547C70.8477 28.309 71.3281 28.0047 71.7166 28.1204C72.9667 28.4933 73.6007 29.4938 73.892 30.7102L73.8932 30.7105C71.8657 21.761 67.0391 26.6855 67.0276 26.6972C63.0632 30.5119 54.6478 54.8835 49.5831 67.1551C44.3057 79.9425 37.9665 86.4599 27.5406 82.0078C28.0475 82.3416 28.5948 82.6674 29.1898 82.9832C40.7872 89.1375 47.5788 82.6259 53.1767 69.0621C57.875 57.6785 65.4564 35.8833 69.6934 29.7438Z"
        fill="#FFAE47"
      />
      <path
        d="M58.1965 45.8816C57.407 45.4626 56.4242 45.7632 56.0056 46.5519C55.5872 47.3405 55.8889 48.3229 56.6786 48.742C57.4682 49.161 58.4508 48.8602 58.8693 48.0715C59.2877 47.2831 58.986 46.3005 58.1965 45.8816Z"
        fill="black"
      />
      <path
        d="M55.403 52.1926C54.6135 51.7736 53.6308 52.0743 53.2123 52.863C52.7938 53.6516 53.0956 54.634 53.8851 55.053C54.6746 55.472 55.6574 55.1713 56.076 54.3826C56.4943 53.5942 56.1926 52.6116 55.403 52.1926Z"
        fill="black"
      />
      <path
        d="M50.5941 58.8439C50.1757 59.6325 50.4775 60.615 51.2671 61.034C52.0567 61.453 53.0391 61.1522 53.4577 60.3635C53.8762 59.5748 53.5742 58.5927 52.7849 58.1739C51.9954 57.7548 51.0126 58.0554 50.5941 58.8439Z"
        fill="black"
      />
      <path
        d="M58.9766 57.3587C60.52 53.3384 62.1157 49.1812 63.6797 45.2842C63.9119 44.7055 63.6299 44.0504 63.0515 43.8154C62.4724 43.5827 61.8146 43.8634 61.5823 44.4418C60.0121 48.3545 58.4133 52.5198 56.8668 56.548C55.1412 61.0433 53.5112 65.2893 52.1322 68.6309C48.5527 77.3041 44.8741 82.0667 40.5559 83.6192C37.4431 84.7383 33.8983 84.2042 29.7189 81.9864C26.47 80.2623 24.4293 78.1024 23.6539 75.5665C22.3255 71.2222 24.8362 66.5217 26.3364 63.7133L26.5549 63.3035C28.3562 59.909 27.289 56.3553 26.4717 54.5052L43.3487 49.3412C44.1829 54.5925 40.6588 59.7584 37.7895 63.9648C35.6087 67.1618 33.8861 69.6868 34.4028 71.7729C34.6196 72.6474 35.1955 73.3383 36.1148 73.8262C38.1167 74.8884 40.1985 72.4586 40.8827 71.6601C42.2058 70.1161 43.7471 67.7981 45.5949 64.5736C45.9048 64.0326 45.717 63.3429 45.1755 63.0325C44.6344 62.724 43.9438 62.9092 43.6339 63.4502C38.7847 71.9123 37.2246 71.8359 37.1731 71.8324C36.6799 71.5707 36.6191 71.3251 36.5961 71.2327C36.3222 70.1266 38.0174 67.6413 39.6568 65.2381C42.6495 60.8509 46.6847 54.93 45.5225 48.6735C46.3243 48.4139 46.9824 47.8651 47.3782 47.1193C47.7823 46.3577 47.8652 45.4842 47.6123 44.6608L47.5967 44.6094C47.0736 42.9071 45.2625 41.9464 43.5601 42.4673L29.9466 46.6329C29.3501 46.8155 29.0152 47.4466 29.1984 48.0429C29.3816 48.639 30.0137 48.9744 30.6099 48.7919L44.2234 44.6264C44.4714 44.5505 44.7341 44.5756 44.9634 44.6973C45.1925 44.8189 45.3605 45.0223 45.4365 45.2691L45.4522 45.3205C45.5283 45.5683 45.5034 45.8309 45.3819 46.0598C45.2604 46.2886 45.057 46.4565 44.8091 46.5323L43.8567 46.8237C43.8564 46.8237 43.8561 46.8239 43.8558 46.8239L24.5211 52.7399L23.3858 53.0873C23.1377 53.1632 22.875 53.138 22.6459 53.0165C22.4168 52.8949 22.2487 52.6915 22.1718 52.4416L22.157 52.3935C21.9998 51.8819 22.2882 51.3383 22.8 51.1818L27.3434 49.7916C27.94 49.609 28.2749 48.9778 28.0917 48.3816C27.9084 47.7855 27.2764 47.4501 26.6801 47.6326L22.1366 49.0228C21.3117 49.2752 20.6349 49.8336 20.2308 50.5952C19.8267 51.3566 19.7437 52.2303 19.9976 53.0569L20.0125 53.105C20.274 53.9561 20.8576 54.6217 21.5886 55.0096C22.3196 55.3975 23.198 55.5076 24.0493 55.2472L24.2935 55.1725C24.9368 56.5367 25.9984 59.5323 24.5591 62.2446L24.3435 62.649C22.7875 65.5619 19.8912 70.9841 21.4938 76.2249C22.4512 79.3555 24.8626 81.965 28.6614 83.9809C33.4355 86.5143 37.5772 87.091 41.3232 85.7446C46.2834 83.9613 50.3821 78.7976 54.222 69.494C55.6111 66.1262 57.2459 61.8673 58.9766 57.3587Z"
        fill="black"
      />
      <path
        d="M85.5679 35.9343C85.5664 35.5176 85.3355 35.1352 84.9672 34.9398L79.7563 32.1746C79.4939 29.9649 78.4012 23.2056 74.7135 21.2487C72.9124 20.2929 71.1149 20.0822 69.3709 20.6226C66.015 21.6623 63.2499 25.3701 60.6299 29.9428L58.4343 28.7776L58.7918 28.104C59.084 27.5532 58.8739 26.8698 58.3226 26.5773C57.7714 26.2847 57.0877 26.4938 56.7954 27.0446L55.0222 30.386C54.7299 30.9368 54.94 31.6202 55.4913 31.9127C56.0426 32.2053 56.7263 31.9962 57.0186 31.4454L57.3761 30.7718L59.5323 31.916C59.1141 32.6887 58.698 33.4773 58.2822 34.2743C57.9588 34.8944 57.6131 35.5746 57.2478 36.3061L55.0562 35.1431L55.4137 34.4695C55.706 33.9187 55.4959 33.2353 54.9446 32.9428C54.3933 32.6502 53.7096 32.8593 53.4173 33.4101L51.6441 36.7515C51.3519 37.3023 51.562 37.9857 52.1133 38.2782C52.6645 38.5708 53.3482 38.3617 53.6405 37.8109L53.998 37.1372L56.2484 38.3314C55.4723 39.9202 54.6239 41.6859 53.7118 43.5843C51.1493 48.9182 48.2449 54.9638 45.4513 60.1658C45.1563 60.715 45.363 61.3996 45.9128 61.6948C45.9146 61.6957 45.9162 61.6966 45.9179 61.6975C46.4669 61.9889 47.1484 61.7826 47.4424 61.235C50.26 55.9884 53.1761 49.9185 55.7489 44.5631C57.5309 40.8538 59.0701 37.6502 60.2859 35.3195C63.2826 29.5751 66.5043 23.8749 70.0416 22.779C71.206 22.4183 72.388 22.5698 73.6553 23.2424C76.0528 24.5146 77.1689 29.7104 77.4966 32.3114L75.2083 33.7612C75.3565 31.1718 75.0013 27.9213 72.0389 27.0381C70.7876 26.6649 69.7971 27.8023 69.4717 28.1762C68.8918 28.842 68.2508 29.8194 67.5115 31.1644C66.2804 33.4047 64.7824 36.664 62.9324 41.1284C62.6936 41.7042 62.9686 42.3649 63.5442 42.604C64.1207 42.8432 64.7814 42.57 65.0202 41.9941C66.65 38.061 67.9869 35.1098 69.107 32.9716C70.5653 30.1882 71.3196 29.4529 71.5771 29.2652C72.517 29.6407 73.4057 30.8427 72.7178 35.8117C72.7169 35.819 72.7174 35.8261 72.7166 35.8334C72.7122 35.8705 72.7106 35.908 72.7099 35.9458C72.7095 35.9633 72.7081 35.9807 72.7086 35.9982C72.7087 36.0023 72.7081 36.0064 72.7083 36.0106C72.7102 36.0581 72.7155 36.1049 72.723 36.1511C72.7234 36.1538 72.7234 36.1567 72.7239 36.1594C72.7331 36.2121 72.7467 36.2636 72.7628 36.3142C72.7681 36.3302 72.775 36.3455 72.7809 36.3613C72.7937 36.3953 72.8072 36.429 72.8231 36.4616C72.8319 36.4795 72.8419 36.4966 72.8516 36.5142C72.8679 36.5434 72.885 36.5719 72.9038 36.5994C72.9155 36.6167 72.9277 36.6336 72.9405 36.6502C72.9607 36.6766 72.9819 36.7017 73.0044 36.7262C73.0183 36.7414 73.032 36.7567 73.0468 36.7712C73.0724 36.7963 73.0997 36.8195 73.1279 36.8423C73.1418 36.8536 73.1549 36.8656 73.1695 36.8763C73.2132 36.9083 73.2589 36.9381 73.3079 36.964L78.6121 39.7788C78.6954 39.823 78.783 39.8562 78.8724 39.8781C79.1408 39.9441 79.4279 39.91 79.6769 39.7764L84.974 36.9306C85.341 36.7341 85.5694 36.3509 85.5679 35.9343ZM79.1369 37.5026L76.0831 35.8821L78.7468 34.1944L82.0408 35.9424L79.1369 37.5026Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_24_922">
        <rect
          width="53"
          height="77"
          fill="white"
          transform="translate(44.0938 5) rotate(27.9532)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PipeIcon = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="50" cy="50" r="50" fill="#5FBDD1" />
    <circle cx="50.5" cy="66.5" r="33.5" fill="#52ACC0" />
    <g clipPath="url(#clip0_25_992)">
      <path d="M46.2943 91.9271H53.0424V8.07407H46.2943V91.9271Z" fill="#F3B573" />
      <path
        d="M47.808 8.07269L49.3215 8.07269L49.3215 91.9273L53.0435 91.9273L53.0435 8.07269L47.808 8.07269Z"
        fill="#F5A257"
      />
      <path d="M46.2946 91.9277H53.0426V86.8656H46.2946V91.9277Z" fill="#F5A257" />
      <path
        d="M54.2247 22.4052L54.1236 39.876L49.7247 39.8777L45.1135 39.8805L45.2145 22.4098L49.8267 22.408L54.2247 22.4052Z"
        fill="#F5A257"
      />
      <path
        d="M54.2247 22.4052L54.1235 39.876L49.7247 39.8777L49.7255 39.8751L49.8267 22.408L54.2247 22.4052Z"
        fill="#DB8F52"
      />
      <path
        d="M50.8084 32.2821C51.4376 31.6529 51.4376 30.6327 50.8084 30.0035C50.1792 29.3743 49.1591 29.3743 48.5299 30.0035C47.9006 30.6327 47.9006 31.6529 48.5299 32.2821C49.1591 32.9113 50.1792 32.9113 50.8084 32.2821Z"
        fill="#735458"
      />
      <path
        d="M53.0433 7.10582L46.2946 7.10582C45.7606 7.106 45.3278 7.53878 45.3277 8.07265L45.3277 16.1088C45.3278 16.6429 45.7606 17.0757 46.2946 17.0757C46.8285 17.0755 47.2613 16.6427 47.2614 16.1088L47.2613 9.03948L52.0764 9.03948L52.0763 21.4395L47.2613 21.4419L47.2614 20.233C47.2615 19.699 46.8286 19.2661 46.2948 19.2662C45.7609 19.2663 45.3278 19.699 45.3279 20.2328V21.4429L45.2141 21.443C44.6824 21.4433 44.2506 21.8727 44.2478 22.4042L44.1468 39.8752C44.1453 40.1327 44.2465 40.3801 44.4281 40.5626C44.6097 40.7451 44.8565 40.8477 45.1139 40.8476L45.3277 40.8475L45.3278 79.5018C45.3279 80.0358 45.7607 80.4686 46.2947 80.4686C46.5616 80.4686 46.8033 80.3603 46.9782 80.1854C47.1531 80.0105 47.2614 79.7687 47.2614 79.5019L47.2615 40.8464L52.0766 40.8438V43.2704C52.0765 43.8045 52.5094 44.2374 53.0433 44.2373C53.3103 44.2373 53.552 44.1291 53.727 43.9541C53.9019 43.7791 54.0102 43.5374 54.0102 43.2705L54.0103 40.8427L54.1241 40.8426C54.3909 40.8426 54.6324 40.7344 54.8073 40.5594C54.9809 40.3858 55.0889 40.1462 55.0904 39.8815L55.1914 22.4107C55.1929 22.1532 55.0917 21.9057 54.9101 21.7232C54.7285 21.5407 54.4817 21.4381 54.2243 21.4383L54.0105 21.4384L54.0105 8.07265C54.0102 7.53869 53.5774 7.10591 53.0433 7.10582ZM53.1624 38.9096L46.0861 38.9134L46.1759 23.376L53.2523 23.3723L53.1624 38.9096Z"
        fill="black"
      />
      <path
        d="M52.0766 47.3943L52.0766 85.8988L47.2615 85.8988L47.2615 83.6238C47.2614 83.0898 46.8286 82.657 46.2947 82.657C45.7608 82.6571 45.3279 83.09 45.3279 83.6238L45.3279 86.8634C45.3279 86.8641 45.3278 86.8648 45.3278 86.8655L45.3278 91.9272C45.3278 91.9576 45.3296 91.9875 45.3323 92.0172C45.3325 92.0191 45.3324 92.0212 45.3326 92.023C45.3451 92.1498 45.3823 92.2692 45.439 92.3767C45.4401 92.3787 45.4409 92.381 45.442 92.383C45.4547 92.4069 45.4689 92.43 45.4836 92.4526C45.4861 92.4565 45.4882 92.4606 45.4907 92.4644C45.5052 92.486 45.521 92.5067 45.5372 92.5271C45.5407 92.5315 45.5438 92.5362 45.5472 92.5406C45.5874 92.5895 45.6321 92.6342 45.681 92.6743C45.6873 92.6796 45.6943 92.684 45.7007 92.6892C45.7191 92.7035 45.7376 92.7178 45.7569 92.7308C45.7635 92.7351 45.7703 92.7387 45.7769 92.743C45.797 92.7557 45.8171 92.7683 45.8381 92.7795C45.8437 92.7825 45.8497 92.7849 45.8553 92.7878C45.8777 92.7992 45.9003 92.8103 45.9236 92.82C45.9286 92.8221 45.9338 92.8236 45.9389 92.8256C45.9631 92.8352 45.9873 92.8443 46.0124 92.8519C46.0189 92.8539 46.0257 92.8552 46.0323 92.857C46.0559 92.8637 46.0794 92.87 46.1036 92.875C46.1185 92.878 46.1335 92.8795 46.1485 92.8819C46.1648 92.8844 46.1807 92.8875 46.1973 92.8892C46.2296 92.8925 46.262 92.8942 46.2948 92.8942L53.0435 92.8942C53.0565 92.8942 53.0689 92.8927 53.0816 92.8922C53.1011 92.8914 53.1206 92.8912 53.1397 92.8892C53.1656 92.8866 53.191 92.8823 53.2164 92.8778C53.2221 92.8768 53.2278 92.8763 53.2336 92.8751C53.2618 92.8695 53.2895 92.8623 53.3168 92.8543C53.3195 92.8534 53.3224 92.8529 53.3251 92.8522C53.3528 92.8438 53.3799 92.8339 53.4065 92.8231C53.409 92.8221 53.4115 92.8214 53.414 92.8204C53.4392 92.8099 53.4637 92.7979 53.4879 92.7855C53.4917 92.7834 53.4957 92.7818 53.4996 92.7798C53.5219 92.7679 53.5432 92.7546 53.5645 92.741C53.5699 92.7375 53.5756 92.7346 53.5809 92.7309C53.601 92.7175 53.6202 92.7028 53.6391 92.6878C53.6449 92.6833 53.6512 92.6792 53.657 92.6745C53.6814 92.6545 53.7047 92.6333 53.727 92.6111C53.7273 92.6107 53.7277 92.6102 53.7281 92.6098C53.75 92.5879 53.7706 92.5651 53.7903 92.5412C53.7959 92.5343 53.8006 92.527 53.806 92.5202C53.82 92.5023 53.834 92.4842 53.8468 92.4652C53.8512 92.4586 53.8549 92.4515 53.8592 92.4448C53.8718 92.4249 53.8843 92.4049 53.8955 92.384C53.8985 92.3785 53.9009 92.3725 53.9037 92.3669C53.9152 92.3445 53.9262 92.322 53.936 92.2985C53.9381 92.2935 53.9396 92.2883 53.9416 92.2833C53.9511 92.2592 53.9602 92.2349 53.9678 92.2098C53.9698 92.2033 53.9711 92.1965 53.9729 92.19C53.9796 92.1664 53.9859 92.1427 53.9909 92.1184C53.9935 92.1056 53.9948 92.0924 53.9968 92.0795C53.9997 92.0613 54.0031 92.0433 54.0049 92.0247C54.0082 91.9926 54.0099 91.9603 54.0099 91.9276L54.0098 86.866L54.0103 47.3943C54.0102 46.8603 53.5774 46.4275 53.0434 46.4275C52.5095 46.4277 52.0767 46.8605 52.0766 47.3943ZM52.0767 87.8323L52.0767 90.9604L47.2615 90.9605L47.2615 87.8324L52.0767 87.8323Z"
        fill="black"
      />
      <path
        d="M50.3528 47.7067C50.7303 47.3291 50.7303 46.717 50.3528 46.3394C49.9752 45.9619 49.3631 45.9619 48.9855 46.3394C48.608 46.717 48.608 47.3291 48.9855 47.7067C49.3631 48.0843 49.9752 48.0843 50.3528 47.7067Z"
        fill="black"
      />
      <path
        d="M50.3528 53.6534C50.7303 53.2758 50.7303 52.6637 50.3528 52.2861C49.9752 51.9085 49.3631 51.9085 48.9855 52.2861C48.608 52.6637 48.608 53.2758 48.9855 53.6534C49.3631 54.0309 49.9752 54.0309 50.3528 53.6534Z"
        fill="black"
      />
      <path
        d="M50.3528 59.6017C50.7303 59.2242 50.7303 58.612 50.3528 58.2345C49.9752 57.8569 49.3631 57.8569 48.9855 58.2345C48.608 58.612 48.608 59.2242 48.9855 59.6017C49.3631 59.9793 49.9752 59.9793 50.3528 59.6017Z"
        fill="black"
      />
      <path
        d="M50.3528 65.5484C50.7303 65.1708 50.7303 64.5587 50.3528 64.1811C49.9752 63.8036 49.3631 63.8036 48.9855 64.1811C48.608 64.5587 48.608 65.1708 48.9855 65.5484C49.3631 65.9259 49.9752 65.9259 50.3528 65.5484Z"
        fill="black"
      />
      <path
        d="M50.3528 71.4969C50.7303 71.1193 50.7303 70.5072 50.3528 70.1296C49.9752 69.752 49.3631 69.752 48.9855 70.1296C48.608 70.5072 48.608 71.1193 48.9855 71.4969C49.3631 71.8744 49.9752 71.8744 50.3528 71.4969Z"
        fill="black"
      />
      <path
        d="M50.3528 77.4435C50.7303 77.066 50.7303 76.4538 50.3528 76.0763C49.9752 75.6987 49.3631 75.6987 48.9855 76.0763C48.608 76.4538 48.608 77.066 48.9855 77.4435C49.3631 77.8211 49.9752 77.8211 50.3528 77.4435Z"
        fill="black"
      />
      <path
        d="M49.3082 28.5903C48.6263 28.6866 48.0221 29.0432 47.6089 29.5931C47.1949 30.1433 47.0201 30.822 47.1163 31.5039C47.3154 32.9113 48.6224 33.8946 50.03 33.6957C50.5894 33.6165 51.0961 33.3626 51.4886 32.9701C51.5744 32.8843 51.655 32.7917 51.7292 32.6928C52.1432 32.1425 52.3181 31.4639 52.2218 30.7822C52.1254 30.1003 51.7692 29.4968 51.2188 29.0828C50.6686 28.6686 49.99 28.4938 49.3082 28.5903ZM50.3071 31.0527C50.3569 31.4043 50.1113 31.7312 49.7593 31.781C49.4074 31.8307 49.0807 31.5848 49.0309 31.2331C49.0068 31.0626 49.0506 30.8929 49.154 30.7554C49.1726 30.7307 49.1928 30.7075 49.2142 30.6861C49.3123 30.5879 49.439 30.5246 49.5788 30.5047C49.7491 30.4805 49.919 30.5244 50.0565 30.6278C50.194 30.7313 50.2831 30.8821 50.3071 31.0527Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_25_992">
        <rect width="66" height="66" fill="white" transform="translate(3 50) rotate(-45)" />
      </clipPath>
    </defs>
  </svg>
);

export const SynthPad = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="50" cy="50" r="50" fill="#F9D184" />
    <g clipPath="url(#clip0_27_1668)">
      <path
        d="M55.25 16.875V20.625C55.25 22.909 53.4092 24.75 51.125 24.75C48.8408 24.75 47 22.909 47 20.625C47 18.7464 45.5036 17.25 43.625 17.25C41.7464 17.25 40.25 18.7464 40.25 20.625V31.875C40.25 31.9976 40.205 32.0862 40.1456 32.1456C40.0862 32.205 39.9977 32.25 39.875 32.25C39.7523 32.25 39.6638 32.205 39.6044 32.1456C39.545 32.0862 39.5 31.9976 39.5 31.875V20.625C39.5 18.3408 41.3408 16.5 43.625 16.5C45.9092 16.5 47.75 18.3408 47.75 20.625C47.75 22.5032 49.2463 24 51.125 24C53.0037 24 54.5 22.5032 54.5 20.625V16.875C54.5 16.7522 54.545 16.6637 54.6044 16.6044C54.6637 16.545 54.7522 16.5 54.875 16.5C54.9978 16.5 55.0863 16.545 55.1456 16.6044C55.205 16.6637 55.25 16.7522 55.25 16.875Z"
        fill="#7F838C"
        stroke="black"
        strokeWidth="3"
      />
      <path
        d="M28.5 34.5H73.5C75.784 34.5 77.8366 35.2147 79.2863 36.306C80.7374 37.3984 81.5 38.7883 81.5 40.1875V52.3849L78.7412 54.5H23.2588L20.5 52.3849V40.1875C20.5 38.7883 21.2626 37.3984 22.7137 36.306C24.1634 35.2147 26.216 34.5 28.5 34.5Z"
        fill="#E67359"
        stroke="black"
        strokeWidth="3"
      />
      <rect x="44.5" y="49" width="33.5" height="2.5" fill="#E67359" />
      <path
        d="M20.5 69.625V54H81.5V69.625C81.5 71.8983 79.6483 73.75 77.375 73.75H24.625C22.3517 73.75 20.5 71.8983 20.5 69.625Z"
        fill="#E6EEFF"
        stroke="black"
        strokeWidth="3"
      />
      <path
        d="M28.375 42.25C29.4105 42.25 30.25 41.4105 30.25 40.375C30.25 39.3395 29.4105 38.5 28.375 38.5C27.3395 38.5 26.5 39.3395 26.5 40.375C26.5 41.4105 27.3395 42.25 28.375 42.25Z"
        fill="black"
      />
      <path
        d="M28.375 49.75C29.4105 49.75 30.25 48.9105 30.25 47.875C30.25 46.8395 29.4105 46 28.375 46C27.3395 46 26.5 46.8395 26.5 47.875C26.5 48.9105 27.3395 49.75 28.375 49.75Z"
        fill="black"
      />
      <path
        d="M35.875 42.25C36.9105 42.25 37.75 41.4105 37.75 40.375C37.75 39.3395 36.9105 38.5 35.875 38.5C34.8395 38.5 34 39.3395 34 40.375C34 41.4105 34.8395 42.25 35.875 42.25Z"
        fill="black"
      />
      <path
        d="M35.875 49.75C36.9105 49.75 37.75 48.9105 37.75 47.875C37.75 46.8395 36.9105 46 35.875 46C34.8395 46 34 46.8395 34 47.875C34 48.9105 34.8395 49.75 35.875 49.75Z"
        fill="black"
      />
      <path d="M60.25 40.5V47.75H45.5V40.5H60.25Z" fill="#5C5C66" stroke="black" strokeWidth="4" />
      <path
        d="M73.875 42.4167H68.375C67.615 42.4167 67 41.6526 67 40.7083C67 39.7641 67.615 39 68.375 39H73.875C74.635 39 75.25 39.7641 75.25 40.7083C75.25 41.6526 74.635 42.4167 73.875 42.4167Z"
        fill="black"
      />
      <path
        d="M73.875 49.25H68.375C67.615 49.25 67 48.486 67 47.5417C67 46.5975 67.615 45.8334 68.375 45.8334H73.875C74.635 45.8334 75.25 46.5975 75.25 47.5417C75.25 48.486 74.635 49.25 73.875 49.25Z"
        fill="black"
      />
      <path
        d="M25 53V66.375C25 67.4105 25.7279 68.25 26.6258 68.25C27.5236 68.25 28.2515 67.4105 28.2515 66.375V53H25Z"
        fill="#050506"
      />
      <path
        d="M30.2025 53V66.375C30.2025 67.4105 30.9304 68.25 31.8282 68.25C32.7261 68.25 33.454 67.4105 33.454 66.375V53H30.2025Z"
        fill="#050506"
      />
      <path
        d="M38.0061 53V66.375C38.0061 67.4105 38.734 68.25 39.6319 68.25C40.5297 68.25 41.2576 67.4105 41.2576 66.375V53H38.0061Z"
        fill="black"
      />
      <path
        d="M43.4254 53V66.375C43.4254 67.4105 44.1533 68.25 45.0511 68.25C45.949 68.25 46.6769 67.4105 46.6769 66.375V53H43.4254Z"
        fill="black"
      />
      <path
        d="M48.8445 53V66.375C48.8445 67.4105 49.5725 68.25 50.4703 68.25C51.3682 68.25 52.0961 67.4105 52.0961 66.375V53H48.8445Z"
        fill="black"
      />
      <path
        d="M69.3293 53V66.375C69.3293 67.4105 70.0572 68.25 70.955 68.25C71.8529 68.25 72.5808 67.4105 72.5808 66.375V53H69.3293Z"
        fill="black"
      />
      <path
        d="M74.7485 53V66.375C74.7485 67.4105 75.4764 68.25 76.3742 68.25C77.2721 68.25 78 67.4105 78 66.375V53H74.7485Z"
        fill="black"
      />
      <path
        d="M56.2147 53V66.375C56.2147 67.4105 56.9426 68.25 57.8405 68.25C58.7383 68.25 59.4663 67.4105 59.4663 66.375V53H56.2147Z"
        fill="black"
      />
      <path
        d="M61.6339 53V66.375C61.6339 67.4105 62.3619 68.25 63.2597 68.25C64.1576 68.25 64.8855 67.4105 64.8855 66.375V53H61.6339Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_27_1668">
        <rect width="64" height="64" fill="white" transform="translate(19 11)" />
      </clipPath>
    </defs>
  </svg>
);

export const SynthLead = () => (
  <svg
    width={SIZE}
    height={SIZE}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="50" cy="50" r="50" fill="#86D0F9" />
    <path
      d="M18 22C18 19.7909 19.7909 18 22 18H77.7875C79.9966 18 81.7875 19.7909 81.7875 22V77C81.7875 79.2091 79.9966 81 77.7875 81H22C19.7909 81 18 79.2091 18 77V22Z"
      fill="#E67359"
    />
    <path
      d="M18 22C18 19.7909 19.7909 18 22 18H77.7875C79.9966 18 81.7875 19.7909 81.7875 22V77C81.7875 79.2091 79.9966 81 77.7875 81H22C19.7909 81 18 79.2091 18 77V22Z"
      stroke="black"
    />
    <path d="M46.4084 30.4308H52.7208V36.7431H46.4084V30.4308Z" fill="#5578D1" />
    <path d="M57.455 33.5869H63.7673V39.8992H57.455V33.5869Z" fill="#5578D1" />
    <path d="M68.5015 30.4308H74.8138V36.7431H68.5015V30.4308Z" fill="#5578D1" />
    <path d="M24.3154 24.1185H40.0962V36.7431H24.3154V24.1185Z" fill="#E4E8ED" />
    <path d="M35.3619 24.1185H40.0962V36.7431H35.3619V24.1185Z" fill="#C8D1DA" />
    <path
      d="M31 55.5C31 53.567 32.567 52 34.5 52V52C36.433 52 38 53.567 38 55.5V55.5C38 57.433 36.433 59 34.5 59V59C32.567 59 31 57.433 31 55.5V55.5Z"
      fill="#5578D1"
    />
    <path
      d="M22 63.5C22 61.567 23.567 60 25.5 60V60C27.433 60 29 61.567 29 63.5V63.5C29 65.433 27.433 67 25.5 67V67C23.567 67 22 65.433 22 63.5V63.5Z"
      fill="#5578D1"
    />
    <path
      d="M31 72.5C31 70.567 32.567 69 34.5 69V69C36.433 69 38 70.567 38 72.5V72.5C38 74.433 36.433 76 34.5 76V76C32.567 76 31 74.433 31 72.5V72.5Z"
      fill="#5578D1"
    />
    <path
      d="M41.4773 23.7373C41.4773 23.185 41.0296 22.7373 40.4773 22.7373H23.7373C23.185 22.7373 22.7373 23.185 22.7373 23.7373V37.3212C22.7373 37.8735 23.185 38.3212 23.7373 38.3212H40.4773C41.0296 38.3212 41.4773 37.8735 41.4773 37.3212V23.7373ZM38.5181 34.3619C38.5181 34.9142 38.0704 35.3619 37.5181 35.3619H26.6966C26.1443 35.3619 25.6966 34.9142 25.6966 34.3619V26.6966C25.6966 26.1443 26.1443 25.6966 26.6966 25.6966H37.5181C38.0704 25.6966 38.5181 26.1443 38.5181 26.6966V34.3619Z"
      fill="black"
    />
    <path
      d="M71.0796 22.5404C70.5273 22.5404 70.0796 22.9881 70.0796 23.5404V28.0496C70.0796 28.6019 69.6319 29.0496 69.0796 29.0496H67.9235C67.3712 29.0496 66.9235 29.4973 66.9235 30.0496V37.3212C66.9235 37.8735 67.3712 38.3212 67.9235 38.3212H69.0796C69.6319 38.3212 70.0796 38.7689 70.0796 39.3212V43.6335C70.0796 44.1858 70.5273 44.6335 71.0796 44.6335H72.0389C72.5912 44.6335 73.0389 44.1858 73.0389 43.6335V39.3212C73.0389 38.7689 73.4866 38.3212 74.0389 38.3212H75.195C75.7473 38.3212 76.195 37.8735 76.195 37.3212V30.0496C76.195 29.4973 75.7473 29.0496 75.195 29.0496H74.0389C73.4866 29.0496 73.0389 28.6019 73.0389 28.0496V23.5404C73.0389 22.9881 72.5912 22.5404 72.0389 22.5404H71.0796ZM73.2358 34.3619C73.2358 34.9142 72.7881 35.3619 72.2358 35.3619H70.8827C70.3305 35.3619 69.8827 34.9142 69.8827 34.3619V33.0089C69.8827 32.4566 70.3305 32.0089 70.8827 32.0089H72.2358C72.7881 32.0089 73.2358 32.4566 73.2358 33.0089V34.3619Z"
      fill="black"
    />
    <path
      d="M60.0331 22.5404C59.4808 22.5404 59.0331 22.9881 59.0331 23.5404V31.2057C59.0331 31.758 58.5854 32.2057 58.0331 32.2057H56.877C56.3247 32.2057 55.877 32.6535 55.877 33.2057V40.4773C55.877 41.0296 56.3247 41.4773 56.877 41.4773H58.0331C58.5854 41.4773 59.0331 41.925 59.0331 42.4773V43.6335C59.0331 44.1858 59.4808 44.6335 60.0331 44.6335H60.9924C61.5447 44.6335 61.9924 44.1858 61.9924 43.6335V42.4773C61.9924 41.925 62.4401 41.4773 62.9924 41.4773H64.1485C64.7008 41.4773 65.1485 41.0296 65.1485 40.4773V33.2057C65.1485 32.6535 64.7008 32.2057 64.1485 32.2057H62.9924C62.4401 32.2057 61.9924 31.758 61.9924 31.2057V23.5404C61.9924 22.9881 61.5447 22.5404 60.9924 22.5404H60.0331ZM62.1893 37.518C62.1893 38.0703 61.7415 38.518 61.1893 38.518H59.8362C59.2839 38.518 58.8362 38.0703 58.8362 37.518V36.165C58.8362 35.6127 59.2839 35.165 59.8362 35.165H61.1893C61.7415 35.165 62.1893 35.6127 62.1893 36.165V37.518Z"
      fill="black"
    />
    <path
      d="M48.9865 22.5404C48.4342 22.5404 47.9865 22.9881 47.9865 23.5404V28.0496C47.9865 28.6019 47.5388 29.0496 46.9865 29.0496H45.8303C45.278 29.0496 44.8303 29.4973 44.8303 30.0496V37.3212C44.8303 37.8735 45.278 38.3212 45.8303 38.3212H46.9865C47.5388 38.3212 47.9865 38.7689 47.9865 39.3212V43.6335C47.9865 44.1858 48.4342 44.6335 48.9865 44.6335H49.9458C50.498 44.6335 50.9458 44.1858 50.9458 43.6335V39.3212C50.9458 38.7689 51.3935 38.3212 51.9458 38.3212H53.1019C53.6542 38.3212 54.1019 37.8735 54.1019 37.3212V30.0496C54.1019 29.4973 53.6542 29.0496 53.1019 29.0496H51.9458C51.3935 29.0496 50.9458 28.6019 50.9458 28.0496V23.5404C50.9458 22.9881 50.498 22.5404 49.9458 22.5404H48.9865ZM51.1426 34.3619C51.1426 34.9142 50.6949 35.3619 50.1426 35.3619H48.7896C48.2373 35.3619 47.7896 34.9142 47.7896 34.3619V33.0089C47.7896 32.4566 48.2373 32.0089 48.7896 32.0089H50.1426C50.6949 32.0089 51.1426 32.4566 51.1426 33.0089V34.3619Z"
      fill="black"
    />
    <path
      d="M22 55.5C22 53.567 23.567 52 25.5 52V52C27.433 52 29 53.567 29 55.5V55.5C29 57.433 27.433 59 25.5 59V59C23.567 59 22 57.433 22 55.5V55.5Z"
      fill="black"
    />
    <path
      d="M31 63.5C31 61.567 32.567 60 34.5 60V60C36.433 60 38 61.567 38 63.5V63.5C38 65.433 36.433 67 34.5 67V67C32.567 67 31 65.433 31 63.5V63.5Z"
      fill="black"
    />
    <path
      d="M22 72.5C22 70.567 23.567 69 25.5 69V69C27.433 69 29 70.567 29 72.5V72.5C29 74.433 27.433 76 25.5 76V76C23.567 76 22 74.433 22 72.5V72.5Z"
      fill="black"
    />
    <path
      d="M45.4125 51.5C45.4125 50.3954 46.3079 49.5 47.4125 49.5H73.3375C74.442 49.5 75.3375 50.3954 75.3375 51.5V76.6375C75.3375 77.7421 74.442 78.6375 73.3375 78.6375H47.4125C46.3079 78.6375 45.4125 77.7421 45.4125 76.6375V51.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M45.4125 51.5C45.4125 50.3954 46.3079 49.5 47.4125 49.5H73.3375C74.442 49.5 75.3375 50.3954 75.3375 51.5V76.6375C75.3375 77.7421 74.442 78.6375 73.3375 78.6375H47.4125C46.3079 78.6375 45.4125 77.7421 45.4125 76.6375V51.5Z"
      stroke="black"
    />
    <path
      d="M58.0125 49.5H62.7375V69.55C62.7375 70.6546 61.842 71.55 60.7375 71.55H60.0125C58.9079 71.55 58.0125 70.6546 58.0125 69.55V49.5Z"
      fill="#0C0303"
    />
    <path
      d="M66.675 49.5H71.4V69.55C71.4 70.6546 70.5046 71.55 69.4 71.55H68.675C67.5705 71.55 66.675 70.6546 66.675 69.55V49.5Z"
      fill="#0C0303"
    />
    <path
      d="M49.35 49.5H54.075V69.55C54.075 70.6546 53.1795 71.55 52.075 71.55H51.35C50.2454 71.55 49.35 70.6546 49.35 69.55V49.5Z"
      fill="#0C0303"
    />
  </svg>
);
